import * as React from "react";
import { connect } from "react-redux";
import { ChangeEvent } from "react";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { toast, ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  FormGroup,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search }  from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import DatePicker from "react-datepicker";
import { Utils } from "../Common/Utilis";
import { CustomerService } from "../Common/Services/CustomerService";
import { PartTemplateService } from "../Common/Services/PartTemplateService";
import { resolve, reject } from "q";
import chevronRight from "../Common/Assets/Images/icons/bx-chevron-right.svg";
import "../App.scss";
import "./slideout.scss";
import "./customer.scss";
import { CustomerSearch } from "../Common/Components/CustomerSearch";
import { JobOrderService } from "../Common/Services/JobOrderService";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { VendorService } from "../Common/Services/VendorService";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { ProductService } from "../Common/Services/ProductService";
import { ConfirmationModal } from "../Common/Components/ConfirmationModal";
import { ConfirmationModalNonTable } from "../Common/Components/ConfirmationModalNonTable";
import { FiChevronDown } from "react-icons/fi";
import moment from "moment-timezone";
import { confirmAlert } from "react-confirm-alert";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  JobCreations from './JobCreations';
import { MdBuild } from 'react-icons/md';
import { debug } from "console";
import Dropzone from "react-dropzone";
import { MdArrowRightAlt } from 'react-icons/md';
import { FaPencilAlt } from 'react-icons/fa';

//import { PricebreakdownPopup } from "./PricebreakdownPopup";
import {
  faPlus,
  faMinus,
  faPaperclip,
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../Common/Components/CommentBox";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { faArrowPointer, faListUl } from '@fortawesome/free-solid-svg-icons';


import PDFViewer from "./pdf-viewer";
import { IoOptions } from "react-icons/io5";
import { title } from "process";
const { SearchBar } = Search;
let routeLeavingGuard: any = null;
let docViewerFiles: any = [];
let orderRequestInProcess = false;
const tooltipMessage =
  "Total Price values here are different than the values in the Quotation line item. Do you want to apply these changes to the line item?";
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let currentUtcTime  = storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
  // let currentUtcTime = "Pacific/Kiritimati";
  const formattedDate  =   Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime);
 class Quotationslideout extends React.Component<any, any> {
  private scrollvdRef: any;
  private customerSearch: any;
  private fileInputRef: any;
  private trDate: any;
  private trdueDate: any;
  private trpoDate: any;
  private checkAllRef: any = {};
  private scrollArea: any = {};
  private parentScroll: any;
  private scrollheight: any;
  private footerchk: any;
  private ChildComment: any;
  private icheckselectedall = (column, colIndex) => {
    return (
      <div className="d-flex align-items-center txt-bold">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="postingRule">Click to copy below all parts</Tooltip>
          }
        >
          <FontAwesomeIcon
            icon={faArrowUp}
            size="xs"
            onClick={(e) => this.handleRowSelectionCheckAll(e, colIndex)}
          />
        </OverlayTrigger>
        {/* <input

                type="checkbox"
                onChange={(e) => this.handleRowSelectionAll(e, colIndex)}
            /> */}
      </div>
    );
  };

  private transactionsColumns = [
    {
      dataField: "id",
      text: "#",
      hidden: true,
    },
    {
      dataField: "itemNo",
      text: "#",
      hidden: true,
    },
    {
      dataField: "srno",
      text: "#",
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {

        return (
          <div>
            {rowIndex + 1}
          </div>
        );
      },
    },
   
    {
      dataField: "partno",
      text: "Part No.",
      headerClasses: "coa",
      style: { overflow: 'inherit' },
      headerStyle: { width: "20%" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "partno" + rowIndex + "btn";
        let id = "partno" + rowIndex + "ddl";
        const defaultPartname = row.partNo;
        // let disable =  false;
        let disable = this.state.formData.CustomerID == 0 ? true : false;

        return (
          <div
          >
            <div className="more-action single-select-image dropdown coa-select">

              {<Typeahead

                id={"partno" + rowIndex + "ddl"}
                className="custom-typeahead"
                inputProps={{
                  className: "form-control form-control-sm partname" + rowIndex + "ddl",
                  title: defaultPartname,
                  onClick: () => this.hoverOutEllipsis()
                }}
                onInputChange={(e) => this.onInputChange(e, this, 1 + "_" + rowIndex + "_" + defaultPartname)}
                options={
                
                  this.state.productList.filter((ele, ind) => ind === this.state.productList.findIndex(elem => elem.partno === ele.partno && elem.partname === ele.partname && ele.partname !== ""))

                }
                placeholder={"Enter Part No"}
                disabled={disable}
                labelKey="partno"

                renderMenu={(results: any, menuProps) => (
              
                <Menu style={{ zIndex: "-1" }} {...menuProps}>
                  <div style={{ display: 'table',  borderCollapse: 'separate', borderSpacing: '0 10px', paddingLeft :'4%' }}>
                    <div style={{ display: 'table-header-group', backgroundColor: '#f5f5f5' }}>
                      <div style={{ display: 'table-row' }}>
                        <div style={{ display: 'table-cell', fontWeight: 'bold', padding: '10px 15px', borderBottom: '1px solid #ddd' }}>
                          Part Number
                        </div>
                        <div style={{ display: 'table-cell',    fontWeight: 'bold', padding: '10px 15px', borderBottom: '1px solid #ddd' }}>
                          Part Description
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'table-row-group' }}>
                      {results.map((result: any, index: any) => (
                        result.label !== "" && result.partno !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                            style={{ display: 'table-row', backgroundColor: '#fff', marginBottom: '5px'}}
                            key={index}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#EBF0F4'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'} 
                            onWheel={() => this.hoverOutEllipsis()}
                          >
                            <div style={{ display: 'table-cell', padding: '10px 15px', borderBottom: '1px solid #eee'}}>
                              {result.partno}
                            </div>
                            <div style={{ display: 'table-cell',  padding: '10px 15px', borderBottom: '1px solid #eee' }}>
                            
                            <div style={{width: '300px'}}>
                 <EllipsisWithTooltip placement="bottom">
                 {result.label}
                </EllipsisWithTooltip>
              </div>
                         
                            </div>
                          </MenuItem>
                        )
                      ))}
                    </div>
                  </div>
                </Menu>


                )}
            
                onChange={this.handleSelectedItem.bind(
                  this,
                  1 + "_" + rowIndex + "_" + defaultPartname
                )}
                selected={row.defaultPartname}
                //allowNew
                onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                onKeyDown={this.onTAB.bind(this, "partno-" + rowIndex.toString() + "ddl", rowIndex)}

              />}

              <button id={btnId} style={{ display: "none", width: "100%" }}
                onClick={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input part" + rowIndex + "ddl", rowIndex); }}
                onFocus={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input part" + rowIndex + "ddl", rowIndex); }} >
                {row.partname === "" && (
                  <EllipsisWithTooltip placement="bottom">{"Enter Part Name"}</EllipsisWithTooltip>
                )}
                {row.partname !== "" && (
                  <EllipsisWithTooltip placement="bottom">{defaultPartname}</EllipsisWithTooltip>
                )}
              </button>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "partname",
      text: "Part Description",
      headerStyle: { width: "25%" },
      hidden: false,
      editable: false,
      classes:"text-truncate",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtpartname" + rowIndex + "txt";
        // let disable = row.jobno != "" || this.state.formData.CustomerID == 0 ? true : false;
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
        
  
            <div style={{ position: 'relative' }}>
            <div className="btn-group w-100">
            
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Part Name"
              // value={row.partname}
              value={row.partname.split('\n')[0]}
              onChange={(e) => this.updateState(e, rowIndex, "partname", id)}
              onBlur={(e) => this.updateStateblur(e, rowIndex, "partname", id)}
              autoComplete="off"
              disabled={disable}
              title={row.partname}
              maxLength={500}
              className="form-control form-control-sm text-truncate"
              style={{ paddingRight: '30px',width:'100%' }} 
            />
            
             <FaPencilAlt 
                onClick={() => this.handleEditClick(rowIndex, row.partname)} 
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }} 
              />
          </div>
     
          </div>
      
        );
      },

    },
    
    // {
    //   dataField: "",
    //   text: "Unit",
    //   headerStyle: { width: "5%" },

    //   hidden: false,
    //   editable: false,
    //   headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
    //   formatter: (cell: any, row: any, rowIndex: any) => {
    //     let id = "txtunit" + rowIndex + "txt";
    //     let disable = this.state.formData.CustomerID == 0 ? true : false;
    //     return (
    //       <div>
    //         <Form.Control
    //           tabIndex={this.state.tabEnable}
    //           id={id}
    //           type="text"
    //           placeholder=""
    //           value={row.unit}
    //           onChange={(e) => this.updateState(e, rowIndex, "unit", id)}
    //           autoComplete="off"
    //           disabled={disable}
    //           title=""
    //           maxLength={50}
    //           className="form-control form-control-sm"
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
          dataField: "unit",
          text: "Unit",
          headerClasses: "coa",
    
          headerStyle: { width: "10%" },
          headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
    
          formatter: (cell: any, row: any, rowIndex: any) => {
            let btnId = "unit" + rowIndex + "btn";
            let id = "unit" + rowIndex + "ddl";
            const defaultitemname = row.defaultunitname;
            let disable = this.state.formData.CustomerID == 0 ? true : false;;
            const options =  this.state.unitList;
            return (
              <div
                style={{ position: 'relative' }}
              >
                <div className="more-action single-select-image dropdown coa-select">
    
                  { <Typeahead
    
                      id={"itemname" + rowIndex + "ddl"}
                      inputProps={{
                        className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl",
                        title: defaultitemname.length > 0 ? `${defaultitemname[0].itemName}`:'',
                      }}
                      options={ options}
                      placeholder={"Enter Unit"}
    
                    // labelKey="label"
    
                    renderMenu={(results: any, menuProps) => (
                      <Menu style={{ zIndex: "-1" }}  {...menuProps}>
                        {results.map((result: any, index: any) => (
                          <>
                            {/* {this.state.inventoryLoad} */}
                            {result.label !== "" && (
                              <MenuItem
                                option={result}
                                position={index}
                              >
                                <EllipsisWithTooltip placement="bottom">
                                  {result.label}
    
                                </EllipsisWithTooltip>
                              </MenuItem>
                            )}
    
                            {result.itemname === "" && (
                              <MenuItem option={result} position={index}></MenuItem>
                            )}
                          </>
                        ))}
                      </Menu>
                    )}
    
                    onChange={this.handleSelectedItem.bind(
                      this,
                      2 + "_" + rowIndex + "_" + defaultitemname
                    )}
                    disabled={disable}
                    selected={row.defaultunitname}
                    allowNew={false}
                  onBlur={this.handleOutsideClickForAdditionalItemsUnit.bind(this, rowIndex)}
                  // onKeyDown={this.onTAB.bind(this, "unit-" + rowIndex.toString() + "ddl", rowIndex)}
    
                  />}
                </div>
    
    
              </div>
            );
          },
        },
    {
      dataField: "",
      text: "Qty",
      headerStyle: { width: "10%" },
     // headerClasses: 'amount',
    //  classes: 'amount',
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtqty" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Qty"
              value={row.qtyOrdered}
              onChange={(e) => this.updateStatePartid(e, rowIndex, "qtyOrdered", id, row.productid)}
              //  onBlur={(e: any) => this.amountBlur(e, rowIndex, "qtyOrdered")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
              className="form-control form-control-sm"
             // style={{ textAlign: 'right' }}
            />
          </div>
        );
      },
    },

    {
      dataField: "unitprice",
      text: "Unit Price",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitprice" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Unit Price"
              value={row.unitPrice}
              onChange={(e) => this.updateState(e, rowIndex, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "unitPrice")}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "unitPrice")}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
            //  className="form-control form-control-sm"
            />
          </div>
        );
      },
    },


    {
      dataField: "qty",
      text: "Discount",
      headerStyle: { width: "5%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdiscount" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Discount"
              value={row.discount}
              onChange={(e) => this.updateState(e, rowIndex, "discount", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "discount")}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "discount")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
              className="form-control form-control-sm"
            />
          </div>
        );
      },
    },

    {
      dataField: "total",
      text: "Total",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txttotal" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder=""
              value={Utils.currencyFormat(Utils.removecurrencyFormat(row.qtyOrdered) * Utils.removecurrencyFormat(row.unitPrice) - Utils.removecurrencyFormat(row.discount))}
              // onChange={(e) => this.updateState(e, rowIndex, "amount", id)}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              //  onBlur={(e: any) => this.amountBlur(e, rowIndex,"amount")}
              onKeyDown={(e: any) => this.handleBlur(e, rowIndex)}
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
              className="form-control form-control-sm"
            // onKeyDown={this.onTAB.bind(this, "txttotal-" + rowIndex.toString() + "txt", rowIndex)}
            />
          </div>
        );
      },
    },

    {
      dataField: "duedate",
      text: "Est. Date",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,

      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtduedate" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div className="date-picker calender-picker" onClick={(e) => this.onclickevent(e)}>
            <DatePicker
              ref={this.trdueDate}
              id={id}
              title="Est. Date"
              tabIndex={this.state.tabEnable}
              className="form-control form-control-sm"
              placeholderText={"MM/DD/YY"}
              dateFormat="MM/dd/yy"
             onChangeRaw={this.handleRawChange}
              selected={
                row.dueDate === null
                  ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                  : row.dueDate === ""
                    ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                    : new Date(row.dueDate)
              }
              onChange={(e) => this.updateState(e, rowIndex, "dueDate", id)}

              onKeyDown={(e: any) =>
                this.onTAB.bind(
                  this,
                  "txtduedate-" + rowIndex.toString() + "txt",
                  rowIndex
                )
              }
              autoComplete="off"
              //onKeyDown={this.onTAB.bind(this, "txttotal-" + rowIndex.toString() + "txt", rowIndex)}
              // disabled={isBedgeProcessing && true}
              disabled={disable}
            />
          </div>
        );
      },
    },

    {
      dataField: '',
      text: 'Action',
      headerStyle: { width: "2%" },

      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        return (
          <div className="btn-group">
            <Dropdown
              // onClick={(e) => { e.stopPropagation(); }}
              className="more-action"
            >
              <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary-white more"
                id={"dropdown-more" + rowIndex}

              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey={"comments"} onClick={() => this.ShowModal(row.productid, row.partNo, row.partname, row.id)}>Price Breakdown </Dropdown.Item>

                {/* <Dropdown.Item eventKey={"selectall"} onClick={() => this.handleOnSelectAll(true,row)}>Select All 
                
                
                </Dropdown.Item> */}

                <Dropdown.Item eventKey={"deleterow"} onClick={() => this.isdeleteconfirm(row.srno)}>Delete


                </Dropdown.Item>
                <Dropdown.Item eventKey={"comments"}  onClick={() => this.handleEditClick1(rowIndex,row.notes)}>{row.notes ? 'Edit Note' : 'Add Note'}</Dropdown.Item>


              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
    },

  ];

  
    private partcolumns = [
      {
        dataField: "id",
        text: "id",
        hidden: true,
        headerStyle: { width: "100px" },
         
      },
     
      {
        dataField: "partno",
        text: "Part No",
        hidden: false,
        headerStyle: { width: "100px" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            
           <div>
              {row.partno}
              </div>
          );
        },
      },
      {
        dataField: "partname",
        text: "Part Description",
        headerStyle: { width: "33%" },
        classes:"text-truncate",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
           
            <div className="d-flex align-items-center txt-bold">
               <div style={{width: '150px'}}>
              <EllipsisWithTooltip placement="bottom">
                {row.partname}
              </EllipsisWithTooltip>
            </div>
            </div>
          );
        },
      
      },
    ];

 private jobcolumns = [
      {
        dataField: "jobId",
        text: "jobId",
        hidden: true,
        headerStyle: { width: "100px" },
         
      },
     
      {
        dataField: "jobNo",
        text: "Job No",
        hidden: false,
        headerStyle: { width: "100px" },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            
           <div>
              {row.jobNo}
              </div>
          );
        },
      }
    ];

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.scrollvdRef = React.createRef();
    this.customerSearch = React.createRef();
    this.trDate = React.createRef();
    this.trpoDate = React.createRef();
    this.trdueDate = React.createRef();
    this.onDrop = this.onDrop.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSaveFiles = this.handleSaveFiles.bind(this);
    this.isHandleAction = this.isHandleAction.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.Previoustransactions = this.Previoustransactions.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.scrollheight = React.createRef();
    this.GetUploadFileList = this.GetUploadFileList.bind(this);
    this.getprocesslist = this.getprocesslist.bind(this);
    this.handleUpdatedFile = this.handleUpdatedFile.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    this.ShowJobModal = this.ShowJobModal.bind(this);
    this.ShowModal = this.ShowModal.bind(this);
    this.fileInputRef = React.createRef();

    // this.isdeleteconfirm=this.isdeleteconfirm.bind(this);
    //this.ishandleDeleteRow=this.ishandleDeleteRow.bind(this);
    this.loadPreviousData = this.loadPreviousData.bind(this);

    this.ChildComment = React.createRef();
    this.state = {
      unitList:[],
      showApplyPopup:false,
      jobList:[],
      selectedPartId:0,
      selectedJobId:0,
      partcolumns: this.partcolumns,
      jobcolumns: this.jobcolumns,
      showPartPopup:false,
      isattachFile:false,
      status:"",
      editingIndex: null,
      currentNote: '',
      showPopup: false,
      editingIndex1: null,
      currentNote1: '',
      showPopup1: false,
      //timeZone:timeZone,
      isicon: false,
      srno1: 1,
      srno2: 2,
      srno3: 5,
      srno4: 10,

    
      updatedqty1: 0,
      updatedqty2: 0,
      updatedqty3: 0,
      updatedqty4: 0,

      updatedqty5: 0,
      requestlistprev: { recordCount: 5000, customerid: 0, tenantid: 0 },
      displayRecordCount: 5,
      searchPreviousData: '',
      showReset: false,
      fileSelect:
        "data:application/pdf;base64,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",
      showBreakdown: false,
      prevOrderidselected: 0,
      isTab: 0,
      isBack: 0,
      CustomerPoNumber: "",
      itemNo: 0,
      partname: "",
      partNo: "",
      orderType: '',
      qtyOrdered: 0,
      leadTime: "0",
      poNumber: 0,
      dueDate: formattedDate, 
      jobDesc: "",
      customerRefNo:"",
      id: 0,
      rNo: '',
      productid: 0,
      Isadded: true,
      rowData: 0,
      defaultView: "doc-view",
      tabEnable: 0,
      orderid: this.props.orderid,
      address: this.props.address,
      customercode: this.props.customercode,
      customerNameLatest: this.props.selectedCustomer,
      selectedCustomer: this.props.selectedCustomer,
      productList: [],
      selectedChk: [],
      Defaultselected: [],
      orderResult: [],
      options: [],
      previousOrderData: [],
      orderResultDetails: [],
      bulkSelect: false,
      isprevious: false,
      files: [],
      files1: [],
      savedfiles: [],
      newSelectfiles: [],
      orderlistitem: [],
      transactionsColumns: this.transactionsColumns,
      totalCount: 0,
      bulkSelectedOrderRows: [],
      isOpenViewer: false,
      currentZoom: 0.7,
      chkIds: [],
      // responsive :"table-responsive",
      isAttachments:true,
      showMailPanel: false,
      mailContent: {
          MailTo: '',
          CC: '',
          Message: '',
          subject:''
        },
      moreActionFileUpload1: [
        { name: "Delete", eventKey: "delete" },
        { name: "Download", eventKey: "download" },
        { name: "View", eventKey: "view" },
      ],
      orderData: [
        {
          srno: 1,
          defaultPartname: [],
          defaultunitname: [],
          id: 0,
          orderID: 0,
          itemNo: 1,
          partname: "",
          partNo: "",
          dueDate: formattedDate,
          jobDesc: "",
          qtyOrdered: 1,
          leadTime: "0",
          unit: "",
          unitPrice: Utils.currencyFormat(0),
          discount: Utils.currencyFormat(0),
          total: Utils.currencyFormat(0),
          tenantid: 0,
          productid: 0,
          jobno: "",
          jobid: 0,
          notes:"",
          isdisabled: false,
        },
        // {
        //   srno:2,
        //   defaultPartname: [],
        //   id: 0,
        //   orderID: 0,
        //   itemNo: 2,
        //   partname: "",
        //   partNo: "",
        //   dueDate: "",
        //   jobDesc: "",
        //   qtyOrdered: 0,
        //   unit: "",
        //   unitPrice: 0,
        //   discount: 0,
        //   total: 0,
        //   tenantid: 0,
        //   productid: 0,
        //   jobno: "",
        //   jobid: 0,
        // },
        // // ,
        // {
        //     // defaultPartname: [],
        //     id: 0, orderID: 0, itemNo: 2, partname: '', partNo: '', dueDate: '', jobDesc: '', qtyOrdered: 0, unit: '', unitPrice: 0, discount: 0, total: 0, tenantid: 0, productid: 0,
        // }
      ],
      defaultorderData: [],
      processdataList: [],
      newRow:
      {
        srno: 1,
        defaultPartname: [],
        defaultunitname: [],
        id: 0,
        orderID: 0,
        itemNo: 1,
        partname: "",
        partNo: "",
        dueDate: formattedDate,
        jobDesc: "",
        qtyOrdered: 1,
        leadTime: "0",
        unit: "",
        unitPrice: 0,
        discount: 0,
        total: 0,
        tenantid: 0,
        productid: 0,
        jobno: "",
        jobid: 0,
        notes:"",
        isdisabled: false,
      },
      totals: {
        qty1: 0,
        qty2: 0,
        qty3: 0,
        qty4: 0,
        qty5: 0,
        partId: 0
      },

      totalsExpand: {
        qty1: 0,
        qty2: 0,
        qty3: 0,
        qty4: 0,
        qty5: 0,
        partId: 0,
        isMatch1: false, isMatch2: false, isMatch3: false, isMatch4: false, isMatch5: false,
      },
      qoSetup: [],
      qoSetupAll: [],
      qoPrice: [{
        "id": 0,
        "tenantId": 0,
        "orderID": 0,
        "partId": 0,
        "detailId": 0,
        "qty": 0,
        "price": 0
      }],
      formData: {
        OrderID: 0,
        CustomerID: 0,
        CustomerName: "",
        CustomerPoNumber: "",
        shippingInstruction: "",
        OrderDate: this.props.orderid > 0 ? null :formattedDate,
        BuyerName: "",
        customerRefNo : "",
        ExternalCustomerPO: "",
        ExternalOrderDate:formattedDate,
        Address: "",
        customercode: "",
        IsEdit: "",
        pricebsetupDto: [],
        OrderItems: [],
        quotationBreakupPrice: [],
        priceBreakupSetup: []
      },
      fileSize: 5242880,
    };
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }


  handleEditClick = (rowIndex, currentDesc) => {
   
    this.setState({
      editingIndex: rowIndex,
      currentNote: currentDesc,
      showPopup: true,
    });
  };

  handleEditClick1 = (rowIndex, currentDesc) => {
   
    this.setState({
      editingIndex1: rowIndex,
      currentNote1: currentDesc,
      showPopup1: true,
    });
  };

    handleNotesSave1 = () => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    const { editingIndex1, currentNote1 } = this.state;
    orderData[editingIndex1].notes = currentNote1;
    this.setState({ showPopup1: false, editingIndex1: null, currentNote1: '' ,orderData, isStateChanged: true});
  };


  handleNotesSave = () => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    const { editingIndex, currentNote } = this.state;
    orderData[editingIndex].partname = currentNote;
    this.setState({ showPopup: false, editingIndex: null, currentNote: '' ,orderData, isStateChanged: true});
  };



  handleUpdatedFile() {
    return this.state.chkIds;
  }
  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    this.setState({ isExtractOption: false });
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else if (chktype === "All") {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.fileNo !== fileNo);
        this.setState({ chkIds: newIds });
        // setchkIds(newIds);
      } else {
        const newIds = [...this.state.chkIds];
        files
          .filter((x) => x.fileNo === fileNo)
          .forEach((element) => {
            for (let inx = 0; inx < element.totalpage; inx++) {
              let id = element.fileNo.toString() + "_" + inx.toString();
              const selectedId1 = `custom_${id}`;
              const newId = this.state.chkIds.filter(
                (x) => x.id === selectedId1
              );
              if (newId.length === 0) {
                let item: any = {};
                item.id = selectedId1;
                item.fileNo = element.fileNo;
                newIds.push(item);
              }
            }
            this.setState({ chkIds: newIds });
            // setchkIds(newIds);
          });
      }
    } else {
      // const selectedId = `custom_${id}`

      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };
  handlePreview = (file: any) => {
    this.setState({ fileSelect: "", isOpenViewer: false }, () => {
      this.setState(
        { fileSelect: file, isOpenViewer: false, fileName: file.name },
        () => {
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    });
  };
  scrollToBottom = () => {

    /* this.parentScroll.current.scrollTo({
       //top: this.parentScroll.current.clientHeight,
       top: this.parentScroll.current.scrollHeight,
       behavior: "smooth",
     }); */
  };

  isdeleteconfirm(row: any) {
    
    let masg = "";

    masg = "Are you sure you want to delete this part?";

    confirmAlert({
      title: "Delete Part",

      message: masg,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.ishandleDeleteRow(row, true),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],

      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  ishandleDeleteRow(row: any, mode: any) {
    
    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    let isStateChanged = true;
    this.setState({ orderData: [] }, () => {
      const orderDataNewc = orderData
        .filter((item) => (row === 0 && item.itemNo !== row.itemNo) || item.srno !== row)
        .map((item, index) => {
          item.itemNo = index + 1;
          return item;
        });

      this.setState(
        {
          orderData: orderDataNewc, isStateChanged: isStateChanged

        }
      );
    });

  }
  updatedCommentItem = () => {

    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.totalAmount;
    return updatedItem;
  };
  CommentModalClose = () => {

    let uniqueno = this.state.formData.uniqueno;
    this.handleDiscard(uniqueno);
  };

  closeSlideOut = () => {
    if (this.state.showBreakdown === false) {
      this.props.closeSlideOut(this.state?.shouldReloadMainPage);
      this.setState({ isOpenViewer: false });
    } else {
      this.setState({ showBreakdown: false });
    }
  };

  closePricebreakdown = () => {
    this.setState({ showBreakdown: false });
    //this.GetorderEntryColoumn();
  };

  closeSlideOut2 = () => {

    this.setState({ showjobrModal: false, isSpinner: false, isOpenViewer: false });

    this.GetorderEntryColoumn();
  };

  reopenSlideOutWithNextJob = () => {
    this.setState({ showjobrModal: false, isSpinner: false, }, () => {
      this.GetorderEntryColoumn(true);
    });


  };


  reopenSlideOutWithReworkJob = () => {
    this.setState({ showjobrModal: false, isSpinner: false, }, () => {
      this.GetorderEntryColoumn(true, true);
    });


  };



  handleNewRow = () => {
    
    let orderData: any = [];
    let newRow: any = {};
    let isStateChanged = true;

    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    let maxValueOfRow = 0;
    let len = 0;
    let maxRno = 0;
    let maxSrno = 0;

    if (orderData.length != 0) {
      maxValueOfRow = Math.max(...orderData.map((o) => o.itemNo), 0);
      len = orderData.length;
      maxRno = maxValueOfRow;
      maxSrno = orderData[len - 1].srno;
    }
    else {

      maxValueOfRow = 0;
      len = 0;
      maxRno = maxValueOfRow;
      maxSrno = 0;
    }
    // if(orderData[len - 1].partNo!="")
    // {

    newRow.itemNo = Number(maxRno) + 1;
    newRow.srno = Number(maxSrno) + 1;
    newRow.dueDate = orderData.length != 0 ? orderData[len - 1].dueDate : moment(new Date()).format("MM/DD/YYYY");
    newRow.qtyOrdered = orderData.length != 0 ? orderData[len - 1].qtyOrdered : 1;
    newRow.leadTime = orderData.length != 0 ? orderData[len - 1].leadTime : "";
    orderData.push(newRow);

    this.setState({ orderData: [] }, () => {
      this.setState({ orderData: orderData, isStateChanged }, () => {
        let len = orderData.length;
        let txtID = "txtpartno" + (len - 1) + "txt";
        // setTimeout(() => {
        //   //  this.trDate.current.setOpen(true);
        //   $("input[id^='" + txtID + "']").focus();
        //   //       $("#tblOrder")
        //   // .find("input[class^='" + txtID + "']")
        //   // .focus();
        // }, 50);

      });
    });
    // }
    // else
    // {

    //   let len = orderData.length;
    //   let txtID = "txtpartno" + (len - 1) + "txt";
    //   setTimeout(() => {
    //     //  this.trDate.current.setOpen(true);
    //     $("input[id^='" + txtID + "']").focus();
    //     //       $("#tblOrder")
    //     // .find("input[class^='" + txtID + "']")
    //     // .focus();
    //   }, 50);
    //   reject();

    // }
    // this.setState({  orderData: orderData, isStateChanged }, () => {
    //   setTimeout(() => {
    //     let txtID =
    //       "txtpartno" +
    //       Number(maxRno) +
    //       "txt";
    //     $("#tblOrder")
    //       .find("input[class^='" + txtID + "']")
    //       .focus();
    //   }, 50);
    // });

    //$("#tblOrder").find("input[class^='" + txtID + "']").focus();
  };


  handleNewRowPrice = () => {

    let qoSetup: any = [];
    let newRow: any = {};
    let isStateChanged = true;

    qoSetup = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.qoSetup))
    );

    newRow = {

      id: 0,
      itemName: "",
      partId: this.state.selectedpartid,
      rowId: qoSetup.length + 1,
      detailId: this.state.detatilselectedid,
      priceId: 0,


      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,

      tenantId: 0
    };

    // let maxValueOfRow = Math.max(...qoSetup.map((o) => o.rowId), 0);
    // let len = qoSetup.length;
    // let maxRno = maxValueOfRow;
    // let maxSrno = qoSetup[len - 1].srno;


    // newRow.itemNo = Number(maxRno) + 1;
    // newRow.srno = Number(maxSrno) + 1;
    // newRow.dueDate = orderData[len - 1].dueDate;
    // newRow.qtyOrdered = orderData[len - 1].qtyOrdered;
    // newRow.leadTime= orderData[len - 1].leadTime;
    qoSetup.push(newRow);

    this.setState({ qoSetup: [] }, () => {
      this.setState({ qoSetup: qoSetup, isStateChanged }, () => {



        let len = this.state.qoSetup.length;
        let txtID = "txtitemname" + (len - 1);
        setTimeout(() => {

          $("input[id^='" + txtID + "']").focus();

        }, 50);

      });
    });

  };
  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  componentDidMount() {
    this.GetUnits();
    this.getprocesslist();
    this.onLoadData();
    let requestlist = { ...this.state.requestlist };
    // this.GetProductlist(requestlist);
    this.GetorderEntryColoumn();
    this.getJobItems();
    // this.GetPricebreakdownlist();

  }

  GetUnits = () => {
  
      let TypeInventory: any = [];
  
      VendorService.GetUnits({})
        .then(async (resultinv: any | null) => {
  
          if (resultinv !== null) {
            resultinv.forEach(element => {
  
              let value = element.name;
              let item: any = {};
              item.id = element.id;
              item.itemname = value;
              item.label = value;
              item.selectitem = element.name;
              TypeInventory.push(item);
  
            });
            this.setState({ unitList: TypeInventory });
  
          }
          resolve();
  
        })
        .catch((error) => {
  
          reject();
        });
  
    };
  

   getJobItems()
    {
      let requestlist = { ...this.state.requestlist };
      JobOrderService.GetJobOrderList(requestlist)
      .then(async (result: any[] | null) => {
        if (result != null) {
            this.setState({ jobList: result });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
    }


  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  // GetPricebreakdownlist() {
  //   let saveRequest: any = {};
  //   saveRequest.orderid = this.state.orderid;
  //   saveRequest.tenantid = 0;
  //   CustomerService.GetPricebreakdown(saveRequest)
  //     .then(async (result: any[] | null) => {
  //       console.log("enter");

  //       if (result != null) {
  //         console.log("pricebreakdown",result);
  //         this.setState({ pricebreakdown: result });
  //       }
  //       resolve();
  //     })
  //     .catch((err: any) => {
  //       this.setState({ isSaveSpinner: false });
  //       reject();
  //     });
  // }

  getprocesslist = () => {
    let processdataList: any = [];
    let requestlist = { ...this.state.requestlist };


    PartTemplateService.GetProcessList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {

          result.forEach(element => {

            let item: any = {};
            item.srno = element.srno;
            item.id = element.id;
            item.name = element.processName;
            item.description = element.pDescription;
            item.isFixed = element.isFixed;
            processdataList.push(item);
            //Typelistprocess.push(item);
          });
          this.setState({
            processdataList: processdataList,

          });




        }
        resolve();
      });
    // .catch((error) => {

    //   reject();
    // });


  };



  GetProductlist = (requestlist: any) => {
    requestlist.customerid = this.state.formData.CustomerID;

    this.setState({ isSpinner: false });
    let orderData: any = [];
    let newRow: any = {};
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    ProductService.GetProductOrderlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ orderData: [] }, () => {
            this.setState(
              {
                orderData: orderData,
                newRow: newRow,
                productList: result,
                isSpinner: this.state.orderid === 0 ? false : false,
              },
              () => {
                let formData = { ...this.state.formData };

                // this.GetorderEntryColoumn();
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  GetorderEntryColoumn = (openNextJob: any = false, reworkJob: any = false) => {
   // console.log("yoo");
    let saveRequest: any = {};
    saveRequest.orderid = this.state.orderid;
    saveRequest.tenantid = 0;
    let joblist: any = [];

    let requestlist = { ...this.state.requestlist };

    let productList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.productList))
    );
    let orderData: any = [];
    CustomerService.GetQuotataionorderdataoptimize(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.customerOrderToUpdateList[0] !== undefined) {

            let custommerSelected: any = [];
           const {mailContent} = this.state;
            let orderArray: any = [];

            let options: any = [];
            // let priceOptions:any = result.priceBreakupDto;
            let priceOptions: any = result.priceBreakupDto;
            //   result.priceBreakupDto.map(item => ({
            //     ...item,
            //     qty1: item.itemName=="Quantity" ? item.qty1,
            //     qty2:item.itemName=="Quantity" ? item.qty2,
            //     qty3: item.itemName=="Quantity" ? item.qty3,
            //     qty4: item.itemName=="Quantity" ? item.qty4

            // }));
            // 


            let expandPriceoptions: any = result.quotationBreakupPrice.map(item => ({
              ...item,
              price: Utils.currencyFormat(item.price),
              selected:item.isSelected || false,

            }));


            expandPriceoptions.forEach((element: any, index: any) => {
              // 
              if (element.id == 0) {
                element.id = index + 1;

              }
            });


            result.customerContact.forEach(element => {

              let item: any = {};
              item.id = element.id;
              item.name = element.firstname;
              options.push(item);

            });

              const defaultContact = result.customerContact.find(
                (contact: any) => contact.isDefault == true
              );
              const defaultEmail = defaultContact?.email || "";
              mailContent.MailTo = defaultEmail;
              

            let mainArray = result.customerOrderToUpdateList[0];
            orderArray = result.customerOrderDetailsToUpdateList;
            let uploadFiles = result.uploadFileList;


            for (let i = 0; i < uploadFiles.length; i++) {
              this["myRef" + i] = React.createRef();
            }


            let formData = { ...this.state.formData };
            formData.OrderID = mainArray.orderID;
            formData.CustomerID = mainArray.customerID;
            formData.CustomerName = mainArray.customerName;
            formData.customercode = mainArray.customercode;
            formData.CustomerPoNumber = mainArray.customerPoNumber;
            formData.shippingInstruction = mainArray.shippingInstructions;
            formData.ExternalCustomerPO = mainArray.externalCustomerPO;
            formData.BuyerName = mainArray.buyerName;
                     formData.customerRefNo = mainArray.customerRefNo;
            let Defaultselected: any = [];
            let objData: any = {};

            objData.id = mainArray.buyerName;
            objData.name = mainArray.buyerName;
            Defaultselected.push(objData);

            formData.ExternalOrderDate = mainArray.externalOrderDate;

            formData.OrderDate = mainArray.orderDate;
            // if(mainArray.orderDate !== null && mainArray.orderDate !== undefined)
            //  {
            //   const regex = /^(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})$/;
            //   const [, day, month, year, time] = mainArray.orderDate.match(regex);
            //   formData.OrderDate = new Date(year,month-1,day);
            //  }  

            formData.Address = mainArray.address;
            custommerSelected.company_name = mainArray.customerName;
            custommerSelected.address = mainArray.address;
            custommerSelected.customer_id = mainArray.customerID;
            custommerSelected.customercode = mainArray.customercode;
            this.customerSearch?.current.handleSelectFromParent(
              custommerSelected
            );

            mailContent.Message = `Dear ${mainArray.customerName}`
                + "\n\nPlease find attached Quotation and Quotation Attachments below. Kindly review the details of this quotation at your earliest convenience.\n\nThank you for your cooperation. \n\nBest Regards\n";
            mailContent.subject = `Quotation - ${mainArray.customerPoNumber}`;
              

            let orderlist: any = [];
            if (orderArray.length > 0) {
              orderArray.forEach((element, index: any) => {
              let defaultunitname: any = [];
              let objUnitname: any = {};

              objUnitname.itemName = element.unit;
              objUnitname.label = element.unit;
              objUnitname.id = 0;
              defaultunitname.push(objUnitname);
              element.defaultunitname = defaultunitname;


                let defaultPartname: any = [];
                let objPartname: any = {};

                // let jobdata = joblist.filter(
                //   (x) => x.partid === element.productid && x.id == element.id
                // );


                objPartname.partname = element.partname;
                objPartname.leadTime = element.leadTime;
                objPartname.label = element.partname;
                objPartname.id = element.productid;
                objPartname.partno = element.partNo;
                objPartname.tenantid = 0;
                objPartname.unit = element.unit;
                objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
                objPartname.noofday = null;
                objPartname.jobDesc = element.partname;
                objPartname.notes = element.notes ? element.notes : "";
                //element.jobDesc;

                defaultPartname.push(objPartname);
                element.defaultPartname = defaultPartname;
                element.srno = index + 1;



                // if (jobdata.length > 0) {
                //   element.jobno = jobdata[0].jobno;
                //   element.jobid = jobdata[0].jobid;
                // }
                // else {
                //   element.jobno = "";
                //   element.jobid = 0;
                // }
                //alert(element.id);

                element.unitPrice = Utils.currencyFormat(element.unitPrice);
                element.discount = Utils.currencyFormat(element.discount);
                element.selected = true;
                orderData.push(element);

                let orderlistItem: any = [];

                //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
                orderlistItem.itemNo = element.itemNo;
                orderlistItem.partname = element.partname;
                orderlistItem.partno = element.partNo;
                orderlistItem.dueDate = element.dueDate;
                orderlistItem.jobDesc =  element.partname;
                //element.jobDesc;
                orderlistItem.qtyOrdered = element.qtyOrdered;
                orderlistItem.leadTime = element.leadTime;
                orderlistItem.notes = element.notes ? element.notes : "";
                orderlistItem.unit = element.unit;
                orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
                orderlistItem.discount = Utils.currencyFormat(element.discount);
                orderlistItem.total = element.total;
                orderlistItem.productid = element.productid;

                orderlistItem.selected = true;
                orderlistItem.jobno = element.jobno;
                orderlistItem.jobid = element.jobid;

                orderlist.push(orderlistItem);
              });
            } else {
              orderData = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.orderData))
              );
            }


            this.setState({ orderData: [] }, () => {

              this.setState(
                {
                  options: options,
                  mailContent,
                  priceBreakupSetup: priceOptions,
                  quotationBreakupPrice: expandPriceoptions.filter(item => item.itemName != "Quantity"),
                  Defaultselected: Defaultselected,
                  editMode: this.state.orderid == 0 ? false : true,
                  orderData: orderData,
                  productList,
                  formData: formData,
                  poNumber: mainArray.poNumber,
                  productid: 0,
                  isSpinner: false,
                  defaultView: "doc-view",
                  selected: mainArray.buyerName,
                  status: mainArray.status,
                },
                () => {
                 this.GetProductlist(requestlist);


                  this.GetUploadFileList(this.state.orderid, 1);
                  this.calculateTotals();

                  if (this.state.savedfiles.length != 0) {
                    // this.OpenViewer();
                  }
                }
              );

            });

          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

    applyTemplate = () => {
         if(this.state.selectedPartId > 0){
          ProductService.GetPartPriceBreakup({productid:this.state.selectedPartId})
      .then(async (result: any | null) => {
        if (result !== null) {

 const updatedQoSetup = this.state.qoSetup.map((item) => {
            const match = result.find((r) => r.priceid == item.priceId);
            if (match) {
              return {
                ...item,
                qty1: match.qty1,
                qty2: match.qty2,
                qty3: match.qty3,
                qty4: match.qty4,
                qty5: match.qty5,
              };
            }
            return item;
          });

      this.setState({  
        selectedPartId:0, selectedJobId:0,     
      showPartPopup:false,
      qoSetup: updatedQoSetup,
     }, () => {
      
        this.calculateTotals();
    });
        }
        resolve();
      });

    }
    
  };

  onclickevent = (e) => {
    //  $("#order").removeClass("table-responsive");
    // this.setState({responsive : "table-responsiveremove"});
  };

  handleRawChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value != undefined) {
      const maxLength = 8; // Set the maximum length you want
      if (e.target.value.length > maxLength) {
        e.preventDefault();
        e.target.value = e.target.value.slice(0, maxLength);
      }
    }
  };

  updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined && e != null) {
      
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );

      let qoSetup = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.qoSetup))
      );
      let quotationBreakupPrice = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.quotationBreakupPrice == undefined ? null : this.state.quotationBreakupPrice))
      );

      let priceBreakupSetup = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.priceBreakupSetup == undefined ? null : this.state.priceBreakupSetup))
      );

      if (type === "discount") {

        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        orderData[index].discount = e.target.value;




        this.setState({ orderData, isStateChanged }, () => {


          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
        // 
        // e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        // orderData[index].discount = e.target.value;

        // this.setState({ orderData, isStateChanged }, () => {
        //   $("#tblOrder")
        //     .find("input[id^='" + txtID + "']")
        //     .focus();
        //   let txtdesc = $("#tblOrder").find(
        //     "input[id^='" + txtID + "']"
        //   )[0] as any;
        //   if (txtdesc !== null && txtdesc !== undefined) {
        //     txtdesc.selectionStart = start;
        //     txtdesc.selectionEnd = end;
        //   }
        // });

      }



      if (type === "partNo") {
        e.preventDefault();



        orderData[index].partNo = e.target.value;


        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "partname") {
        e.preventDefault();



        orderData[index].partname = e.target.value;


        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }


      if (type === "dueDate") {
        //  e.preventDefault();

        //  orderData[index].dueDate = e.target.value;
debugger;

let today = new Date(e);
let dateNew =
  today.getMonth() +
  1 +
  "/" +
  today.getDate() +
  "/" +
  today.getFullYear().toString().substring(2, 4);
let todaynew = new Date(dateNew);
let dateNewt =
  todaynew.getMonth() +
  1 +
  "/" +
  todaynew.getDate() +
  "/" +
  todaynew.getFullYear().toString().substring(0, 4);
//formData.OrderDate = dateNewt;       


orderData[index].dueDate =dateNewt;
        //let  responsive ="table-responsiveadd";
        //  this.setState({ formData, isStateChanged });
        //$("#order").addClass("table-responsive");
        this.setState({ orderData, isStateChanged }, () => {
          let id = "txtdescription" + index + "txt";
          //$("#tblOrder").find("input[id^='" + id + "']").focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + id + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "jobDesc") {
        e.preventDefault();

        orderData[index].jobDesc = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "qtyOrdered") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        orderData[index].qtyOrdered = e.target.value;
        priceBreakupSetup.forEach(element => {

          if (element.itemName == 'Quantity') {

            element.qty1 = e.target.value;

          }
        });

        this.setState({ orderData, priceBreakupSetup, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "leadTime") {
        e.preventDefault();
        //   let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        // e.target.value = newVal;
        orderData[index].leadTime = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "unit") {
        e.preventDefault();
        //let newVal = Utils.removeInvaildCharFromAmount(e.target.value);

        orderData[index].unit = e.target.value;
        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

        // this.setState({ orderData, isStateChanged }, () => {
        //   $("#tblOrder")
        //     .find("input[id^='" + txtID + "']")
        //     .focus();
        //   let txtdesc = $("#tblOrder").find(
        //     "input[id^='" + txtID + "']"
        //   )[0] as any;
        //   if (txtdesc !== null && txtdesc !== undefined) {
        //     txtdesc.selectionStart = start;
        //     txtdesc.selectionEnd = end;
        //   }
        // });
      }

      if (type === "unitPrice") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        orderData[index].unitPrice = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          this.calculateTotals();
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "price") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        quotationBreakupPrice[index].price = e.target.value;

        this.setState({ quotationBreakupPrice, isStateChanged }, () => {

          $("#tblCOAchild")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblCOAchild").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      }


      if (type === "qty1") {

        e.preventDefault();
        // let newVal =Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].qty1 = e.target.value;

        this.setState({ qoSetup }, () => {
          this.calculateTotals();
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }


      if (type === "qty2") {

        e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].qty2 = e.target.value;

        this.setState({ qoSetup }, () => {
          this.calculateTotals();
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "qty3") {

        e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].qty3 = e.target.value;

        this.setState({ qoSetup }, () => {
          this.calculateTotals();
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "qty4") {

        e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].qty4 = e.target.value;

        this.setState({ qoSetup }, () => {
          this.calculateTotals();
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "qty5") {

        e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].qty5 = e.target.value;

        this.setState({ qoSetup }, () => {
          this.calculateTotals();
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "itemName") {

        e.preventDefault();
        // let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        // e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        qoSetup[index].itemName = e.target.value;

        this.setState({ qoSetup, isStateChanged }, () => {
          $("#tblpricebreakup")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblpricebreakup").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }


    }
  };

  reopen = () => {
    setTimeout(() => {
      const {orderData} = this.state;
      const partid = orderData[orderData.length - 1].productid;
      const detailid = orderData[orderData.length - 1].id;
      let updatedQuotations: any = [];
      updatedQuotations = this.state.priceBreakupSetup.filter(item => item.partId === partid && item.itemName!="" && item.detailId === detailid) ;

      this.setState({         
      showBreakdown: true,
      selectedpartid: partid,
      qoSetup: updatedQuotations,
     }, () => {
      
        this.calculateTotals();
    });
  }, 5000);

  };

  updateStatePartid = (e: any, index: any, type: any, txtID, partid) => {
    if (this != undefined && e != null) {
      
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );

      let qoSetup = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.qoSetup))
      );
      let quotationBreakupPrice = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.quotationBreakupPrice == undefined ? null : this.state.quotationBreakupPrice))
      );

      let priceBreakupSetup = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.priceBreakupSetup == undefined ? null : this.state.priceBreakupSetup))
      );









      if (type === "qtyOrdered") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        orderData[index].qtyOrdered = e.target.value;
        priceBreakupSetup.forEach(element => {

          if (element.itemName == 'Quantity' && element.partId == partid) {

            element.qty1 = e.target.value;

          }
        });

        this.setState({ orderData, priceBreakupSetup, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }






    }
  };



  onLoadData() {
    this.setState({ isjobcreate: false });
    let pros = this.props;

    let requestlist = { ...this.state.requestlist };
    if (this.customerSearch.current !== null) {
      this.customerSearch.current.GetCustomerTranlist(requestlist);

      let txtID = "form-control searchVendor VendorDisabled";
       
          setTimeout(() => {
              $("input[class^='" + txtID + "']").focus();
          }, 1000);
      
    }
  }

  updateCustomerList = (result: any) => {
    this.setState({ customerList: [] }, () => {
      this.setState({ customerList: result });
    });
  };

  handleCellEdit = (oldValue, newValue, row, column, rowIndex, columnIndex) => {
    const { qoSetup } = this.state;
    
    const updatedData = qoSetup.map(item => {
      if (item.priceId === row.priceId) {
        // Check if the column being edited is a quantity field or a material field
        // if (column.dataField.startsWith('qty')) {
        // Convert the new value to a number
      
        // console.log("itemin",item);

        return { ...item, [column.dataField]: parseInt(newValue) || 0 }; // Default to 0 if parsing fails
        // } else {
        //   // For non-numeric fields, keep the new value as a string
        //   return { ...item, [column.dataField]: newValue };
        // }

      }
     // console.log("itemout", item);
      return item;
    });
    
    // Update state and recalculate totals
    this.setState({ qoSetup: updatedData }, this.calculateTotals);
  };




  handleChange = (event: any, FieldType: string) => {

    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "CustomerName") {
      formData.CustomerName =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "CustomerPoNumber") {
      formData.CustomerPoNumber =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "shippingInstructions") {
      formData.shippingInstruction =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "ExternalCustomerPO") {
      formData.ExternalCustomerPO =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "BuyerName") {
      formData.BuyerName =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "customerRefNo") {
      formData.customerRefNo =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }

    
    else if (FieldType === "ExternalOrderDate") {
      // formData.ExternalOrderDate = event.toISOString();
      // this.setState({ formData, isStateChanged });

      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.ExternalOrderDate = dateNewt;
      // this.setState({ formData, isStateChanged });
    }

    else if (FieldType === "orderDate") {
      //   formData.OrderDate = event.target.value.trim().length > 0 ? event.target.value : "";
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.OrderDate = dateNewt;
      //   this.setState({ formData, isStateChanged });
    } else if (FieldType === "address") {
      formData.address = event.target.value.replace("'", "");
    } else if (FieldType === "check") {
      if (event.target.value.length > 0) {
        if (Number(event.target.value)) {
          formData.checkNo = Number(event.target.value);
        }
      } else {
        formData.checkNo = event.target.value;
      }
    } else if (FieldType === "repeat") {
      formData.isRepeat = event.target.checked ? "Yes" : "No";
      this.setState({ isRepeat: event.target.checked });
    }
    else if (FieldType === "SearchPreviousData") {
      this.setState({ searchPreviousData: event.target.value });
    }else if (FieldType === "Message") {
      event.preventDefault();
      this.state.mailContent.Message = event.target.value;
    }
    else if (FieldType === "CC") {
      event.preventDefault();
      this.state.mailContent.CC = event.target.value;
    } else if (FieldType === "subject") {
      event.preventDefault();
      this.state.mailContent.subject = event.target.value;
    }
    else if (FieldType === "MailTo") {
      event.preventDefault();
      this.state.mailContent.MailTo = event.target.value;
    }


    this.setState({ formData, isStateChanged, isSpinner: false }, () => {
      if (FieldType === "invoiceno") {
        let txtID = "txtInvoice";
        let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
        txtInvoice.selectionStart = start;
        txtInvoice.selectionEnd = end;
      }
    });
  };

  handleDatePicker = (event: any, refName: any) => {
    refName.current.setOpen(true);
  };


  handleCustomerChange = (e: any) => {

    let isStateChanged = true;
    if (e.length > 0) {

      let requestlist = { ...this.state.requestlist };

      let formData = { ...this.state.formData };
      requestlist.vid = e[0].customer_id;
      formData.CustomerID = e[0].customer_id;
      formData.CustomerName = e[0].company_name;
      formData.address = e[0].address;
      formData.customercode = e[0].customercode;
      // formData.BuyerName = e[0].firstname;

      let options: any = [];


        let Defaultselected: any = [];
      
      if(e[0].customerContact==undefined)
      {
        let item: any = {};
        item.id = 0;
        item.name =  e[0].firstname;
        options.push(item);
        let objData: any = {};
        objData.id = 0;
        objData.name = e[0].firstname;
        Defaultselected.push(objData);
        this.state.formData.BuyerName = e[0].firstname;
        formData.BuyerName = e[0].firstname;

      }
      else
      {
      e[0].customerContact.forEach(element => {

        let item: any = {};
        item.id = element.id;
        item.name = element.firstname;
        options.push(item);

      });
  
      // let objData: any = {};
      // let Defaultselected: any = [];
      let defaultname: any = e[0].customerContact.filter(
        (x) => x.isDefault == true
      );
      if (defaultname.length > 0) {
 let objData: any = {};
        objData.id = defaultname[0].firstname;
        objData.name = defaultname[0].firstname;
        Defaultselected.push(objData);
        formData.BuyerName = defaultname[0].firstname;
        this.state.formData.BuyerName = defaultname[0].firstname;
        const defaultEmail = defaultname[0]?.email || "";
        this.state.mailContent.MailTo = defaultEmail;
      };

    }


      this.setState({
        Defaultselected: Defaultselected,
        options: options,
        CustomerName: e[0].company_name,
        address: e[0].address,
        customercode: e[0].customercode,
        isStateChanged: isStateChanged
      });
      this.state.formData.CustomerID = e[0].customer_id;
      this.state.formData.CustomerName = e[0].company_name;

      if (e[0].apartment != "") {
        this.state.formData.Address =
          // e[0].firstname +
          // " " +
          e[0].address +
          "\n" +
          e[0].apartment +
          "\n" +
          e[0].city +
          ", " +
          e[0].state +
          "\n" +
          e[0].zipcode +
          " " +
          e[0].country;
      }
      else {
        this.state.formData.Address =
          e[0].address +
          "\n" +
          e[0].city +
          ", " +
          e[0].state +
          "\n" +
          e[0].zipcode +
          " " +
          e[0].country;

      }
      this.state.formData.customercode = e[0].customercode;

      this.GetProductlist(requestlist);

      // this.GetorderEntryColoumn();

      // if (this.state.orderid == 0) {
      //  this.Previoustransactions();
      //}
      let txtID = "txtOrderDate";
      // setTimeout(() => {
      // //  this.trDate.current.setOpen(true);
      // //  this.trpoDate.current.setOpen(true);
      // //  $("input[id^='" + txtID + "']").focus();
      // }, 50);


      // if (controlID === "txtExternalOrderDate") {
      //   this.trpoDate.current.setOpen(true);
      //   }
    } else {
    }
  };

  // handleCustomerChange = (e: any) => {
  //   let isStateChanged = true;
  //   if (e.length > 0) {
  //     let requestlist = { ...this.state.requestlist };

  //     let formData = { ...this.state.formData };
  //     requestlist.vid = e[0].customer_id;
  //     formData.CustomerID = e[0].customer_id;
  //     formData.CustomerName = e[0].company_name;
  //     formData.address = e[0].address;
  //     formData.customercode = e[0].customercode;
  //     this.setState({
  //       CustomerName: e[0].company_name,
  //       address: e[0].address,
  //       customercode: e[0].customercode,
  //       isStateChanged: isStateChanged
  //     });
  //     this.state.formData.CustomerID = e[0].customer_id;
  //     this.state.formData.CustomerName = e[0].company_name;

  //     this.state.formData.Address =
  //       e[0].firstname +
  //       " " +
  //       e[0].address +
  //       ", " +
  //       e[0].apartment +
  //       " " +
  //       e[0].city +
  //       ", " +
  //       e[0].state +
  //       ", " +
  //       e[0].zipcode +
  //       ", " +
  //       e[0].country;
  //     this.state.formData.customercode = e[0].customercode;

  //     this.GetProductlist(requestlist);

  //     this.GetorderEntryColoumn();
  //     // if (this.state.orderid == 0) {
  //     this.Previoustransactions();
  //     //}
  //     let txtID = "txtOrderDate";
  //     setTimeout(() => {
  //       this.trDate.current.setOpen(true);
  //       //  this.trpoDate.current.setOpen(true);
  //       $("input[id^='" + txtID + "']").focus();
  //     }, 50);


  //     // if (controlID === "txtExternalOrderDate") {
  //     //   this.trpoDate.current.setOpen(true);
  //     //   }
  //   } else {
  //   }
  // };

  GetCustomerlist = (requestlist: any) => {
    CustomerService.GetCustomerlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {


          this.setState({ customerList: result, isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

  handleBlur = (event, rowIndex) => {
    if (event.key.toLowerCase() === "tab") {
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      //orderData[rowIndex].amount = event.target.value === '' ? '' : !isNaN(event.target.value) ? Number(event.target.value).toFixed(2) : 0;
      this.setState({ orderData }, () => {
        if (orderData.length === rowIndex + 1) {

          this.handleNewRow();

          //  let len = this.state.orderData.length;
          // let txtID = "partno" + (len - 1) + "txt";
          // setTimeout(() => {
          // //  this.trDate.current.setOpen(true);
          //   $("input[id^='" + txtID + "']").focus();
          // //       $("#tblOrder")
          // // .find("input[class^='" + txtID + "']")
          // // .focus();
          // }, 50);
        }
      });
    }
  };

  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut();
    });
  }

  onTAB = (control, rowIndex1, event) => {

    let controlID = control.split("-")[0];
    let rowIndex = Number(rowIndex1);


    // let txtID = "txtExternalOrderDate";
    // setTimeout(() => {
    //   this.trpoDate.current.setOpen(true);
    // //  this.trpoDate.current.setOpen(true);
    //   $("input[id^='" + txtID + "']").focus();
    // }, 50);
    if (event.key.toLowerCase() === "enter") {
      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    if (event.key.toLowerCase() === "tab") {

      let ChecktxtID = "partname" + rowIndex + "ddl";

      if (controlID === "partno") {

        this.setState({ isTab: 1 });
        //  let isStateChanged: any;
        //     isStateChanged = true;

        //     let orderDatan = Object.assign(
        //       [],
        //       JSON.parse(JSON.stringify(this.state.orderData))
        //     );
        //     let defaultPartnamen: any = [];
        //     let productListn = Object.assign(
        //       [],
        //       JSON.parse(JSON.stringify(this.state.productList))
        //     );

        //     let maxValueOfRow = Math.max(...productListn.map((o) => o.id), 0);
        //     let len = productListn.length;
        //     let maxRno = maxValueOfRow;

        //     if (event.target.value != "") {
        //       let objPartnamen: any = {};
        //       objPartnamen.id = Number(maxRno) + 1;
        //       objPartnamen.partno = orderDatan[rowIndex].partNo;
        //       objPartnamen.partname = event.target.value;
        //       //objPartnamen.label =e.target.value;

        //       objPartnamen.tenantid = 0;
        //       objPartnamen.unit = "";
        //       objPartnamen.unitPrice = 0;
        //       objPartnamen.noofday = null;
        //       objPartnamen.pdescription = "";
        //       objPartnamen.label = event.target.value;


        //       if (orderDatan[rowIndex].partNo != "" && event.target.value != "") {

        //         let partname2: any = productListn.filter(
        //           (x) => x.partno ==event.target.value
        //         );
        //         if (partname2.length > 0) {
        //           if (partname2[0].partname ==event.target.value && partname2[0].partNo == orderDatan[rowIndex].partNo) { }
        //           else {
        //             defaultPartnamen.push(objPartnamen);
        //             productListn.push(objPartnamen);
        //           }
        //         } else {
        //           defaultPartnamen.push(objPartnamen);
        //           productListn.push(objPartnamen);
        //         }

        //       }
        //       orderDatan[rowIndex].productid = objPartnamen;
        //       orderDatan[rowIndex].partname = event.target.value;
        //       orderDatan[rowIndex].defaultPartname = defaultPartnamen;

        //       //element.defaultPartname = defaultPartname;

        //       this.setState(
        //         { orderData: [], defaultPartname: [], productList: [] },
        //         () => {
        //           this.setState({
        //             orderData: orderDatan,
        //             defaultPartname: defaultPartnamen,
        //             productList: productListn,
        //             isStateChanged
        //           });

        //           // setTimeout(() => {

        //           //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //           //        $("input[id^='" + txtID1 + "']").focus();
        //           // }, 50);
        //         }
        //       );

        //       // console.log(this.state.orderData);

        //       // console.log(this.state.productList);
        //     } else {
        //       let orderData = Object.assign(
        //         [],
        //         JSON.parse(JSON.stringify(this.state.orderData))
        //       );
        //       this.setState({ orderData: [] }, () =>
        //         this.setState({ orderData }, () => {
        //           // setTimeout(() => {

        //           //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //           //       $("#tblOrder")
        //           //         .find("input[id^='" + txtID1 + "']")
        //           //         .focus();
        //           // }, 50);

        //         })
        //       );
        //     };

        // let txtID = "txtpartname" + rowIndex + "txt";

        // $("#tblOrder")
        //   .find("input[id^='" + txtID + "']")
        //   .focus();
          let txtID1 = "txtpartname" + rowIndex + "txt";
          setTimeout(() => {
         // $("input[id^='" + txtID1 + "']").focus();
                  $("#tblOrder")
                    .find("input[id^='" + txtID1 + "']")
                    .focus();
                  }, 50);



        // let txtID =
        //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
        // $("#tblOrder")
        //   .find("input[class^='" + txtID + "']")
        //   .focus();
      }

      if (controlID === "txtduedate") {
        let txtID = "txtdescription" + rowIndex + "txt";

        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
      }

      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    let start = event.target?.selectionStart;
    let end = event.target?.selectionEnd;
    if (event.key.toLowerCase() === "backspace") {
      this.setState({ pstart: start - 1, pend: end - 1 });
    }
    else
      this.setState({ pstart: start + 1, pend: end + 1 });

    // if (event.key.toLowerCase() === "backspace") {
    //   
    //   this.setState({isBack:1});

    //   let controlID = control.split("-")[0];

    //   if (controlID === "partname") {

    //     let rowIndex = Number(rowIndex1);
    //     let orderData = Object.assign(
    //       [],
    //       JSON.parse(JSON.stringify(this.state.orderData))
    //     );
    //     let defaultPartname: any = [];
    //     let productList = Object.assign(
    //       [],
    //       JSON.parse(JSON.stringify(this.state.productList))
    //     );

    //     orderData[rowIndex].partname =  event.target.value;
    //     //event.target.value;
    //     orderData[rowIndex].productid = 0;
    //     orderData[rowIndex].partNo = orderData[rowIndex].partNo;
    //     orderData[rowIndex].unitPrice = 0;
    //     orderData[rowIndex].unit = "";
    //     orderData[rowIndex].jobDesc = "";

    //     let objPartname: any = {};
    //     objPartname.partname = event.target.value;
    //     objPartname.label = event.target.value;
    //     objPartname.id = 0;
    //     objPartname.partno = orderData[rowIndex].partNo;
    //     objPartname.tenantid = 0;
    //     objPartname.unit = "";
    //     objPartname.unitPrice = 0;
    //     objPartname.noofday = null;
    //     objPartname.jobDesc = "";
    //     defaultPartname.push(objPartname);

    //     orderData[rowIndex].defaultPartname = defaultPartname;

    //     this.setState({ orderData, defaultPartname, productList }, () => {
    //       setTimeout(() => {

    //       let txtID =
    //         "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
    //       $("#tblOrder")
    //         .find("input[class^='" + txtID + "']")
    //         .focus();
    //       }, 50);
    //     });


    //   }
    // }
  };

  HidecloseSlideOut() {
    this.props.closeSlideOut();
    this.setState({ isSaveSpinner: false });
  }


  Hidespinner() {


    this.setState({ isSpinner: false });

  }

  saveOrderfinal = (entryType, isCopy, hideSlideOut = true,printAfterSave = false) => {


    // if (orderRequestInProcess == true) {
    //   toast.error("Subsequent request has been made.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //   });
    //   return;
    // }

    orderRequestInProcess = true;
    this.setState({ isSaveSpinner: true, isDisabled: true, unsave: false,isattachFile:false });
    if (entryType == "orderjob") {
      this.setState({ unsave: false, isSaveSpinner: true });
    }

    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let iszeroQty=0;
    let isvalidate = 0;
    let isNegative = 0;
    let orderlistItem: any = [];
    let orderdata = this.state.orderData;
    orderdata.forEach(element => {
      let item: any = {};

      if (element.defaultPartname.length > 0) {
        if (element.partname == "") {

          isempty = 1;
        }


       if(element.qtyOrdered==0)
       {

        iszeroQty = 1;
       }


          item.Id = element.id;
          item.orderID = element.orderID;
          item.itemNo = element.itemNo;
          item.partname = element.partname;
          //element.partname[0].partname === undefined ? element.partname==undefined ? "" : element.partname  : element.partname[0].partname;
          item.partNo = element.partNo;
      
          debugger;
          // item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : element.dueDate;
          item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : Utils.toLocalISOString(new Date(element.dueDate));
          item.jobDesc =  element.partname;
          //element.jobDesc;
          item.unit = element.unit;
          // item.leadTime = parseInt(element.leadTime);
          item.unitPrice = Utils.removecurrencyFormat(element.unitPrice);
          item.qtyOrdered = element.qtyOrdered;
          item.discount = Utils.removecurrencyFormat(element.discount);
          item.total = 0;
          item.leadTime = element.leadTime;
          item.notes = element.notes ? element.notes  : "";
          //Utils.removecurrencyFormat(element.total);
          item.tenantid = element.tenantid;
          console.log("ooo",element.dueDate,this.state.formData.OrderDate);
        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }
        if (new Date(element.dueDate) < new Date(this.state.formData.OrderDate)) {
          isvalidate = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {

          item.productid = 0;
        }
        orderlistItem.push(item);
      }
      else {

        isempty = 1;
      }



    });
    const partnames = new Set();
    let hasDuplicates = false;


       if (isvalidate == 1) {
      isFormValid = false;
      toast.error("Please check Est. date of parts.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }


    orderlistItem.forEach(item => {
      const partname = item.partname;
      if (partnames.has(partname)) {
        hasDuplicates = true;
      } else {
        partnames.add(partname);
      }
    });



    // if (hasDuplicates) {
    //   isFormValid = false;
    //   toast.error("Part Name should be unique", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   this.setState({ isSaveSpinner: false, isDisabled: false });
    //   return;
    // }

    this.state.formData.OrderItems = orderlistItem;

    if (this.state.quotationBreakupPrice != undefined) {
      let quotationbreakup: any = this.state.quotationBreakupPrice.map(item => ({
        ...item,
        price: item.qty == 0 || item.qty == "" ? 0 : Utils.removecurrencyFormat(item.price),
        qty: item.qty == "" ? 0 : item.qty,
        IsSelected: item.selected ? item.selected : false
      }));


      this.state.formData.QuotationBreakupPrice = quotationbreakup.filter(item => item.itemName != 'Quantity');
    }

    
    if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }

 

if( iszeroQty == 1)
{

  isFormValid = false;
  toast.error("Please check qty.", {
    position: toast.POSITION.BOTTOM_RIGHT,
    containerId: "OrderSlideout",
  });
  this.setState({ isSaveSpinner: false, isDisabled: false });
  iszeroQty = 0;
  // this.setState({ isSaveSpinner: false });
  return false;
}

    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      isempty = 0;
      // this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.customer_id === 0 && !isCopy) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return false;
    }

    
    //
    // this.state.formData.PriceBreakupSetup=this.state.qoSetup;
      this.state.formData.ExternalOrderDate = Utils.toLocalISOString(new Date(this.state.formData.ExternalOrderDate));
      // this.state.formData.OrderDate = Utils.toLocalISOString(new Date(this.state.formData.OrderDate));


    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    request.OrderDate = Utils.toLocalISOString(new Date(this.state.formData.OrderDate));


    isFormValid = true;
    //   console.log("form", request);
    //  return;
    if (isFormValid) {
     // console.log(request);
      this.setState({ saveRequest: request, ispopupshow: false });

      CustomerService.QuotataionSaveorder(request)
        .then(async (result: any | null) => {
       //   console.log("result", result);
          if (result !== null) {
            // this.setState({ isSaveSpinner: false });
            if (this.state.orderid === 0) {
              this.setState({ orderid: result.orderID });
              if (!printAfterSave) {
              toast.success(result.customerPoNumber + " order has been created.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
            }

              if (hideSlideOut)
                this.HidecloseSlideOut();
              else {
                //this.ShowJobModal(row.itemNo, row.productid, row.partname, row.partNo, row.qtyOrdered, row.poNumber, row.dueDate, row.jobDesc, row.id, row.jobid);
              }
            }
            else {
            if (!printAfterSave) {
              toast.success("Order has been updated.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
            }
            }
            // this.setState({ isSaveSpinner: false },()=>{this.setState({ isSaveSpinner: false });});


            this.setState(
              {


              },
              () => {
                this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: true });
                this.GetorderEntryColoumn();
                 if (printAfterSave) {
                this.printItem();
              }

              });

            // let requestlist = { ...this.state.requestlist };
            // this.GetProductlist(requestlist);

            // if(hideSlideOut)
            //   this.HidecloseSlideOut();
            // else
            // {
            //   //this.ShowJobModal(row.itemNo, row.productid, row.partname, row.partNo, row.qtyOrdered, row.poNumber, row.dueDate, row.jobDesc, row.id, row.jobid);
            // }

          }
          resolve();
          orderRequestInProcess = false;
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          orderRequestInProcess = false;
          reject();
        });
    }
  };
  convertorder = (entryType, isCopy, hideSlideOut = true,attachment) => {
    this.setState({ isSaveSpinner: true });



    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let isvalidate = 0;
    let isNegative = 0;
    let orderlistItem: any = [];
    let orderdata = this.state.orderData;
    let quotationBreakupPrice = this.state.quotationBreakupPrice.filter(x => x.selected == true);

    orderdata.forEach((element: any, index: any) => {
      // orderdata.forEach(element => {
      let item: any = {};
      if (element.selected == true) {
        

        //  let selectedquotation= quotationBreakupPrice.filter(x=>x.partId==element.productid);

        //  if(selectedquotation.length>1)
        //  {
        //   toast.error("Choose any one price beakup for convert to order.", {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //     containerId: "OrderSlideout",
        //   });
        //   isFormValid=false;

        //   this.setState({ isSaveSpinner: false, isDisabled: false });

        //   return ;

        //  }


        // if(selectedquotation.length!=0)
        // {
        //   element.unitPrice=selectedquotation[0].price;
        // }

debugger;
        item.id = element.id;
        item.orderID = element.orderID;
        item.itemNo = element.itemNo;
        item.partname = element.partname;

        item.partNo = element.partNo;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : element.dueDate;
        item.jobDesc = element.partname;
        //element.jobDesc;
        item.unit = element.unit;

        item.unitPrice = Utils.removecurrencyFormat(element.unitPrice);
        item.qtyOrdered = element.qtyOrdered;
        item.discount = Utils.removecurrencyFormat(element.discount);
        item.total = 0;
        item.leadTime = element.leadTime;
        //Utils.removecurrencyFormat(element.total);
        item.tenantid = element.tenantid;

        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }

        if (new Date(element.dueDate) < new Date(this.state.formData.OrderDate)) {
          isvalidate = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {

          item.productid = 0;
        }
        orderlistItem.push(item);

      }




    });

    this.state.formData.OrderItems = orderlistItem;


    if (this.state.formData.OrderItems.length === 0 && isFormValid == true) {

      isempty = 1;
    }

    if (isvalidate == 1) {
      isFormValid = false;
      toast.error("Please check Est. date of parts.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }


    if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }


    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select atleast one part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      isempty = 0;
      // this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.customer_id === 0 && !isCopy) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return false;
    }

    this.state.formData.ExternalOrderDate = new Date(this.state.formData.ExternalOrderDate);
    this.state.formData.attachment = this.state.savedfiles.length > 0 ? attachment : false;

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));



    //console.log("form", request);

    if (isFormValid) {
      this.setState({ saveRequest: request, ispopupshow: false });



  


      CustomerService.ConvertedQuotationOrder(request)
        .then(async (result: any | null) => {
         // console.log("result", result);
          if (result !== null) {
            toast.error("Quotation has been converted to Customer Order.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.closeSlideOut();


          }
          resolve();
          orderRequestInProcess = false;
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          orderRequestInProcess = false;
          reject();
        });
    }

  };

  checkorder = (entryType, isCopy, hideSlideOut = true,attachment) => {
    this.setState({ isSaveSpinner: true });



    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let isvalidate = 0;
    let isNegative = 0;
    let orderlistItem: any = [];
    let orderdata = this.state.orderData;
    let quotationBreakupPrice = this.state.quotationBreakupPrice.filter(x => x.selected == true);

    orderdata.forEach((element: any, index: any) => {
      // orderdata.forEach(element => {
      let item: any = {};
      if (element.selected == true) {
        

        //  let selectedquotation= quotationBreakupPrice.filter(x=>x.partId==element.productid);

      
        item.id = element.id;
        item.orderID = element.orderID;
        item.itemNo = element.itemNo;
        item.partname = element.partname;

        item.partNo = element.partNo;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : element.dueDate;
        item.jobDesc = element.partname;
        //element.jobDesc;
        item.unit = element.unit;

        item.unitPrice = Utils.removecurrencyFormat(element.unitPrice);
        item.qtyOrdered = element.qtyOrdered;
        item.discount = Utils.removecurrencyFormat(element.discount);
        item.total = 0;
        item.leadTime = element.leadTime;
        //Utils.removecurrencyFormat(element.total);
        item.tenantid = element.tenantid;

        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }

        if (new Date(element.dueDate) < new Date(this.state.formData.OrderDate)) {
          isvalidate = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {

          item.productid = 0;
        }
        orderlistItem.push(item);

      }




    });

    this.state.formData.OrderItems = orderlistItem;


    if (this.state.formData.OrderItems.length === 0 && isFormValid == true) {

      isempty = 1;
    }


    if (isvalidate == 1) {
      isFormValid = false;
      toast.error("Please check Est. date of parts.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }

        if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }

    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select atleast one part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      isempty = 0;
      // this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.customer_id === 0 && !isCopy) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return false;
    }


    this.state.formData.ExternalOrderDate = new Date(this.state.formData.ExternalOrderDate);

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));



    //console.log("form", request);

    if (isFormValid) {
      this.setState({ saveRequest: request, ispopupshow: false });



      CustomerService.CheckQuotationOrder(request)
      .then(async (result: any | null) => {
        debugger;
       // console.log("result", result);
        if (result !== null) {
        debugger;
        if(result=="" || result==null)
        {
this.convertorder(entryType, isCopy, hideSlideOut = true,attachment);

        }
        else
{
  let masg = "";

      masg = "This quotation is already converted Customer Order No. " + result + ". Do you want create new customer order?";

      confirmAlert({
        title: "Confirm Quotation",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.convertorder(entryType, isCopy, hideSlideOut = true,attachment),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
  
}




        }
        resolve();
       
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        orderRequestInProcess = false;
        reject();
      });


    
    }

  };

  showprevious = () => {

    if (this.state.isprevious == false) {
      this.setState({ isprevious: true });
    }
    else {
      this.setState({ isprevious: false });
    }

  };


  saveOrder = (entryType, isCopy) => {

    if (this.state.savedfiles.length != 0 || this.state.newSelectfiles != 0) {
      this.setState({ ispopupshow: false, isSpinner: true });

      if (this.state.newSelectfiles.length > 0) {
        if (this.state.formData.CustomerID == 0 || this.state.formData.CustomerID == "") {
          this.setState({ isSpinner: false });
        }
        else {

          this.handleSaveFiles(this.state.newSelectfiles);
        }
      }
      else {

        this.saveOrderfinal("order", false, true);
      }

    }
    else {
      this.setState({ ispopupshow: true, isSpinner: true });

    }


  };

  isHandleAction() {
    // this.setState({ ispopupshow: false }, () => this.changeTransactionType(this.state.saveentryType, this.state.saverequest, false))
    //     request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    //       this.state.formData.OrderItems=this.state.orderData;
    //    ispopupshow: false;
    //
    //    CustomerService.Saveorder(this.state.formData)
    //    .then(async (result: any | null) => {
    //        if (result !== null) {
    //            this.setState({ isdefaultColDisabled: false });
    //            if (result.saveStatus === "Success") {
    //                toast.success("saved for " + this.state.formData.vendorName + " successfully.", {
    //                    position: toast.POSITION.BOTTOM_RIGHT,
    //                    containerId: "OrderSlideout",
    //                });
    //            }
    //            else {
    //                toast.error(result.message, {
    //                    position: toast.POSITION.BOTTOM_RIGHT,
    //                    containerId: "OrderSlideout",
    //                });
    //            }
    //        }
    //        resolve();
    //    })
    //    .catch((error) => {
    //        this.setState({ isdefaultColDisabled: false });
    //        reject();
    //    });
  }


  handleSaveFiles(files: any) {
    // this.setState({ isSaveSpinner: true });

    //     let isFormValid = true;
    //     let request: any = {};
    //     let isNegative = 0;
    //     let orderdata = this.state.orderData;
    //     let orderlistItem: any = [];
    //     orderdata.forEach((element) => {
    //       let item: any = {};

    //       item.Id = element.id;
    //       item.orderID = element.orderID;
    //       item.itemNo = element.itemNo;
    //       item.partname =
    //         element.partname[0].partname === undefined
    //           ? element.partname
    //           : element.partname[0].partname;
    //       item.partNo = element.partNo;
    //       item.dueDate =
    //         element.dueDate === "" ||
    //           element.dueDate === undefined ||
    //           element.dueDate === null
    //           ? new Date()
    //           : element.dueDate;
    //       item.jobDesc = element.jobDesc;
    //       item.unit = element.unit;
    //       item.unitPrice =Utils.removecurrencyFormat(element.unitPrice);;
    //       item.qtyOrdered = element.qtyOrdered;
    //       item.discount = Utils.removecurrencyFormat(element.discount);
    //       item.total = 0; 
    //       //Utils.removecurrencyFormat(element.total);
    //       item.tenantid = element.tenantid;

    //       if ( Utils.removecurrencyFormat(element.qtyOrdered) *  Utils.removecurrencyFormat(element.unitPrice) -  Utils.removecurrencyFormat(element.discount) < 0) {

    //         isNegative = 1;
    //       }


    // if (isNegative == 1) {
    //     isFormValid = false;
    //     toast.error("Total Amount should not negative.", {
    //       position: toast.POSITION.BOTTOM_RIGHT,
    //       containerId: "OrderSlideout",
    //     });
    //     this.setState({ isSaveSpinner: false, isDisabled: false });
    //     return;
    //   }
    //       if (element.productid == 0) {
    //         item.productid = 0;
    //       } else {
    //         if (element.productid[0] == undefined) {
    //           item.productid = 0;
    //         } else {
    //           item.productid =
    //             element.productid[0].id === undefined
    //               ? element.productid
    //               : element.productid[0].id;
    //         }
    //       }

    //       orderlistItem.push(item);
    //     });

    //     this.state.formData.OrderItems = orderlistItem;
    //   // this.state.formData.ExternalOrderDate=new Date(this.state.formData.ExternalOrderDate);
    //     request = Object.assign(
    //       {},
    //       JSON.parse(JSON.stringify(this.state.formData))
    //     );

    //     if (request.customer_id === 0) {
    //       toast.error("Please select Customer.", {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         containerId: "OrderSlideout",
    //       });

    //       return false;
    //     }

    //     isFormValid = true;

    let orderlistItem: any = [];
    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let isNegative = 0;
    let isvalidate = 0;
    let orderdata = this.state.orderData;
    orderdata.forEach(element => {
      let item: any = {};

      if (element.defaultPartname.length > 0) {
        if (element.partname == "") {

          isempty = 1;
        }

        item.Id = element.id;
        item.orderID = element.orderID;
        item.itemNo = element.itemNo;
        item.partname = element.partname;
        //element.partname[0].partname === undefined ? element.partname==undefined ? "" : element.partname  : element.partname[0].partname;
        item.partNo = element.partNo;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ?new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : element.dueDate;
        item.jobDesc = element.partname;
        //element.jobDesc;
        item.unit = element.unit;
        item.leadTime = element.leadTime;
        item.unitPrice = parseFloat(Number(Utils.removecurrencyFormat(element.unitPrice)).toFixed(2));
        item.qtyOrdered = element.qtyOrdered;
        item.discount = parseFloat(Number(Utils.removecurrencyFormat(element.discount)).toFixed(2));
        item.total = parseFloat(Number(Utils.removecurrencyFormat(element.unitPrice)).toFixed(2));
        //Utils.removecurrencyFormat(element.total);
        item.tenantid = element.tenantid;

        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }

  if (new Date(element.dueDate) < new Date(this.state.formData.OrderDate)) {
          isvalidate = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {
          // if (element.productid[0] == undefined) {
          //   item.productid = element.productid;

          // }
          // else {
          //   item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
          // }
          item.productid = 0;
        }
        orderlistItem.push(item);
      }
      else {

        isempty = 1;
      }



    });

     if (isvalidate == 1) {
      isFormValid = false;
      toast.error("Please check Est. date of parts.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }
    

    this.state.formData.OrderItems = orderlistItem;
    if (this.state.quotationBreakupPrice != undefined) {
      let quotationbreakup: any = this.state.quotationBreakupPrice.map(item => ({
        ...item,
        Price: item.qty == 0 || item.qty == "" ? 0 : Utils.removecurrencyFormat(item.price),
        Qty: item.qty == "" ? 0 : item.qty,
        OrderID: item.orderID,
        Id:item.id,
        IsSelected: item.isSelected
      }));


      this.state.formData.QuotationBreakupPrice = quotationbreakup.filter(item => item.itemName != 'Quantity');
    }
    //
    // this.state.formData.PriceBreakupSetup=this.state.qoSetup;
     if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isSpinner:false,isDisabled: false });
      return;
    }

    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isSpinner:false,isDisabled: false });
      isempty = 0;
      return false;
    }

    if (request.customer_id === 0) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isSpinner:false,isDisabled: false });
      return false;
    }



    this.state.formData.ExternalOrderDate = moment(this.state.formData.ExternalOrderDate).format("MM/DD/YYYY");
    this.state.formData.OldOrderID = 0;
    this.state.formData.UserName = "";

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    request.CustomerRefNo = this.state.formData.customerRefNo;


    
    isFormValid = true;


    if (isFormValid) {

      this.setState({ saveRequest: request });

      CustomerService.QuotationSavefiles(request, files)
        .then(async (result: any | null) => {
          if (result !== null) {
            this.GetUploadFileList(result.orderID, 1);
            if (this.state.orderid === 0) {
              this.setState({ orderid: result.orderID });
              toast.success(
                result.customerPoNumber + " order has been created.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                }
              );
            } else {
              toast.success("Order has been updated.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
            }
            this.setState(
              {


              },
              () => {
                this.setState({ isSaveSpinner: false, isSpinner:false,isDisabled: false, isStateChanged: true });
                this.GetorderEntryColoumn();


              });
            // this.HidecloseSlideOut();
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false });
          reject();
        });
    }
  }

  GetUploadFileList = (uniqueNo, type) => {
    let requestlist: any = {};

    requestlist.orderid = uniqueNo;

    CustomerService.GetQuotationUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          //filelist = _.sortBy(filelist, "newname");
          this.setState(
            (prevState) => ({
              savedfiles: filelist,
              isAttachmentLoading: false,
              isOpenViewer: false,
              newSelectedfiles: [],
              files: [],
              bulkSelect: true,
            }),
            () => {
              setTimeout(() => {
                this.scrollheight.current?.getElement().scrollTo({
                  top: Number(this.state.currentScreenTop),
                  behavior: "smooth",
                });
              }, 500);
            }
          );
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        }

        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({
          isOpenViewer: false,
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          bulkSelect: false,
        });
      });
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };
  hoverOutEllipsis1 = () => {

    //  $("#order").removeClass("table-responsive");
  };

  handleTabKeyDown = (e, rowIndex: number, field: string) => {
    // if (e.key === 'Tab') {
    //   // e.preventDefault(); 
    //  console.log("ooo",rowIndex,field);
    //   // Get the next field
    //   const nextField = this.getNextFieldId(rowIndex, field);
    //    console.log("nextField",nextField);

    //     let txtID = 'txt'+nextField.toString()+'txt';

    //     $("#tblpricebreakup")
    //       .find("input[id^='" + txtID + "']")
    //       .focus();
    // // setTimeout(() => {
    //   // const nextElement = document.getElementById('txt'+nextField.toString()+'txt');
    //   // if (nextElement) {
    //   //   (nextElement as HTMLElement).focus();
    //   // } else {
    //   //   console.warn(`Field with ID '${nextField}' not found.`);
    //   // }
    // // }, 5);
    // }
  };

  getNextFieldId = (rowIndex: number, currentField: string) => {
    const fieldOrder = ['itemName', 'qty1', 'qty2', 'qty3', 'qty4', 'qty5'];

    const currentIndex = fieldOrder.indexOf(currentField);

    const nextIndex = currentIndex + 1;

    if (nextIndex < fieldOrder.length) {
      return `${fieldOrder[nextIndex]}${rowIndex}`;
    }

    return `${fieldOrder[1]}${rowIndex + 1}`;
  };



  amountBlur = (e, rowIndex, type: any) => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {
          orderData[rowIndex].unitPrice = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
        if (type === "discount") {
          orderData[rowIndex].discount = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
        if (type === "qtyOrdered") {
          orderData[rowIndex].qtyOrdered = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
        if (type === "qty1") {
          this.state.qoSetup[rowIndex].qty1 = timeArray[0];
          // Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
        if (type === "price") {
          this.state.quotationBreakupPrice[rowIndex].price = Utils.currencyFormat(
            timeArray[0]
          );
        }
        if (type === "qty2") {
          this.state.qoSetup[rowIndex].qty2 = timeArray[0];
          // Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
        if (type === "qty3") {
          this.state.qoSetup[rowIndex].qty3 = timeArray[0];
          //  Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
        if (type === "qty4") {
          this.state.qoSetup[rowIndex].qty4 = timeArray[0];
          // Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
        if (type === "qty5") {
          this.state.qoSetup[rowIndex].qty5 = timeArray[0];
          // Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
      } else {
        if (type === "unitPrice") {
          orderData[rowIndex].unitPrice = Utils.currencyFormat(
            e.target.value
          );
        }
        if (type === "qty1") {
          this.state.qoSetup[rowIndex].qty1 = e.target.value;
        }
        if (type === "qty2") {
          this.state.qoSetup[rowIndex].qty2 = e.target.value;
        }
        if (type === "qty3") {
          this.state.qoSetup[rowIndex].qty3 = e.target.value;
        }
        if (type === "qty4") {
          this.state.qoSetup[rowIndex].qty4 = e.target.value;
        }
        if (type === "qty5") {
          this.state.qoSetup[rowIndex].qty5 = e.target.value;
        }
        if (type === "price") {
          this.state.quotationBreakupPrice[rowIndex].price = Utils.currencyFormat(e.target.value);
        }

        if (type === "discount") {
          orderData[rowIndex].discount = Utils.currencyFormat(
            e.target.value
          );
        }
        if (type === "qtyOrdered") {
          orderData[rowIndex].qtyOrdered = Utils.currencyFormat(
            e.target.value
          );
        }

      }

      this.setState({ orderData, qoSetup: this.state.qoSetup, quotationBreakupPrice: this.state.quotationBreakupPrice });
    } else {
      if (type === "unitPrice") {
        orderData[rowIndex].unitPrice =
          e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
      }
      if (type === "price") {
        this.state.quotationBreakupPrice[rowIndex].price =
          e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
      }
      if (type === "qty1") {
        this.state.qoSetup[rowIndex].qty1 =
          e.target.value === ""
            ? "0"
            : !isNaN(e.target.value)
              ? e.target.value
              : e.target.value;

      }
      if (type === "qty2") {
        this.state.qoSetup[rowIndex].qty2 =
          e.target.value === ""
            ? "0"
            : !isNaN(e.target.value)
              ? e.target.value
              : e.target.value;

      }
      if (type === "qty3") {
        this.state.qoSetup[rowIndex].qty3 =
          e.target.value === ""
            ? "0"
            : !isNaN(e.target.value)
              ? e.target.value
              : e.target.value;

      }
      if (type === "qty4") {
        this.state.qoSetup[rowIndex].qty4 =
          e.target.value === ""
            ? "0"
            : !isNaN(e.target.value)
              ? e.target.value
              : e.target.value;

      }
      if (type === "qty5") {
        this.state.qoSetup[rowIndex].qty5 =
          e.target.value === ""
            ? "0"
            : !isNaN(e.target.value)
              ? e.target.value
              : e.target.value;

      }
      if (type === "discount") {
        orderData[rowIndex].discount =
          e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
      }
      this.setState({ orderData, qoSetup: this.state.qoSetup, quotationBreakupPrice: this.state.quotationBreakupPrice });
    }
  };

  updateStateBreak = (e: any, index: any, type: any, txtID, id: any, partId: any, dynamicTableId: any) => {
    if (this != undefined && e != null) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      //  
      let quotationBreakupPrice = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.quotationBreakupPrice))
      );
      let priceBreakupSetup = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.priceBreakupSetup))
      );


      // qoSetup.filter(x=>x.itemName!="Quantity")
      if (type === "price") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        // quotationBreakupPrice[index].price = e.target.value;
        quotationBreakupPrice.forEach(element => {

          if (element.id == id && element.partId == partId) {
            // 
            element.price = e.target.value;
          }
        });

        // quotationBreakupPrice.map(r => r.id).price= e.target.value;
        this.setState({ quotationBreakupPrice, isStateChanged }, () => {

          // $("#tblCOAchild")

          $("#" + dynamicTableId)
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#" + dynamicTableId).find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      }
      if (type === "qty") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        //quotationBreakupPrice[index].qty = e.target.value;
        quotationBreakupPrice.forEach(element => {

          if (element.id == id && element.partId == partId) {
            // 
            element.qty = e.target.value;
          }
        });
        

        priceBreakupSetup.forEach(element => {
          
          if (element.itemName == 'Quantity' && element.partId == partId) {
            // 
            // element.qty = e.target.value;
            if (index == 0) {

              element.qty2 = e.target.value;
            }
            if (index == 1) {

              element.qty3 = e.target.value;
            }
            if (index == 2) {

              element.qty4 = e.target.value;
            }

            if (index == 3) {

              element.qty5 = e.target.value;
            }

          }
        });




        this.setState({ priceBreakupSetup, quotationBreakupPrice, isStateChanged }, () => {

          // $("#tblCOAchild")
          $("#" + dynamicTableId)
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#" + dynamicTableId).find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

      }

    }
  };
  amountBlurBreak = (e, rowIndex, type: any, id: any, partId: any) => {

    // let quotationBreakupPrice= Object.assign(
    //   [],
    //   JSON.parse(JSON.stringify(this.state.quotationBreakupPrice))
    // );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {


        if (type === "price") {
          this.state.quotationBreakupPrice.forEach(element => {

            if (element.id == id && element.partId == partId) {
              // 
              element.price = Utils.currencyFormat(
                timeArray[0]
              );
            }
          });
          // this.state.quotationBreakupPrice[rowIndex].price = Utils.currencyFormat(
          //   timeArray[0]
          // );
        }
      }
    }




  };

  onAmountFocusBreak = (e, index, txtID, type: any, id: any, partId: any) => {

    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    
    let quotationBreakupPrice = Object.assign([], JSON.parse(JSON.stringify(this.state.quotationBreakupPrice)));
    if (type === "price") {
      // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      // e.target.value = newVal;
      // this.state.quotationBreakupPrice[index].price = e.target.value;
      



      // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      // e.target.value = newVal;
      quotationBreakupPrice.forEach(element => {

        if (element.id == id && element.partId == partId) {
          // 
          element.price = e.target.value;
        }
      });

      this.setState({ quotationBreakupPrice }, () => {
        $("#tblCOAchild")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblCOAchild").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }


  };



  onAmountFocus = (e, index, txtID, type: any) => {

    let orderData = Object.assign([], JSON.parse(JSON.stringify(this.state.orderData)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      orderData[index].unitPrice = e.target.value;

      this.setState({ orderData }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }

    if (type === "qty1") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.qoSetup[index].qty1 = e.target.value;
    }
    if (type === "qty2") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.qoSetup[index].qty2 = e.target.value;
    }
    if (type === "qty3") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.qoSetup[index].qty3 = e.target.value;
    }
    if (type === "qty4") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.qoSetup[index].qty4 = e.target.value;
    }
    if (type === "qty5") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.qoSetup[index].qty5 = e.target.value;
    }
    if (type === "price") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      this.state.quotationBreakupPrice[index].price = e.target.value;
    }

    if (type === "discount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      orderData[index].discount = e.target.value;

      this.setState({ orderData }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }


    // this.setState({ orderData }, () => {
    //     $("#tblOrder").find("input[id^='" + txtID + "']").focus();
    // });
  };
  handleSelectedItem = (control: any, id: any) => {



    if (this != undefined) {


      let isStateChanged = true;
      // $("#order").removeClass("table-responsive");
      let formData = { ...this.state.formData };
      let controlID = Number(control.split("_")[0]);
      let rowIndex = Number(control.split("_")[1]);

      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
       let unitList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.unitList))
      );
      let defaultPartname: any = [];
      let productList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.productList))
      );
      if (controlID === 1) {
         console.log("id",id);
        if (id.length > 0 && this.state.isTab == 0) {
          if (id[0].id > 0) {

            orderData[rowIndex].partname = id[0].partname;
            orderData[rowIndex].productid = id;

            orderData[rowIndex].partNo = id[0].partno;
            orderData[rowIndex].unitPrice = id[0].unitPrice;
            orderData[rowIndex].leadTime = id[0].leadTime;
            orderData[rowIndex].unit = id[0].unit;
            orderData[rowIndex].jobDesc = id[0].pdescription;
            orderData[rowIndex].defaultPartname = id[0].partname;
            let objPartname: any = {};
            objPartname.partname = id[0].partname;
            objPartname.label = id[0].partno;
            objPartname.id = id;
            objPartname.partno = id[0].partno;

            objPartname.tenantid = 0;
            objPartname.unit = id[0].unit;
            objPartname.unitPrice = id[0].unitPrice;
            objPartname.noofday = null;
            objPartname.jobDesc = id[0].pdescription;
            defaultPartname.push(objPartname);
            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = defaultPartname;
            // this.setState(
            //   { orderData, defaultPartname, productList, isStateChanged },
            //   () => {
            //     //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
            //     ///$("input[class^='" + txtID + "']").focus();
            //     // let txtID = "txtpartno" + rowIndex + "txt";
            //     // $("#tblOrder")
            //     //   .find("input[id^='" + txtID + "']")
            //     //   .focus();

            //     let txtID1 = "txtduedate" + rowIndex + "txt";
            //     $("#tblOrder")
            //       .find("input[id^='" + txtID1 + "']")
            //       .focus();
            //   }
            // );
          } else {

            orderData[rowIndex].partname = id[0].label;
            orderData[rowIndex].productid = 0;
            orderData[rowIndex].partNo = orderData[rowIndex].partNo;
            orderData[rowIndex].unitPrice = 0;
            orderData[rowIndex].unit = "";
            orderData[rowIndex].jobDesc = "";
            orderData[rowIndex].defaultPartname = id[0].label;
            let objPartname: any = {};
            objPartname.partname = id[0].label;
            objPartname.label = id[0].label;
            objPartname.id = 0;
            objPartname.partno = orderData[rowIndex].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = "";
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";
            defaultPartname.push(objPartname);
            // productList.push(objPartname);

            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = id;

            this.setState(
              { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
              () => {
                //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                ///$("input[class^='" + txtID + "']").focus();
                // let txtID = "txtpartno" + rowIndex + "txt";
                // $("#tblOrder")
                //   .find("input[id^='" + txtID + "']")
                //   .focus();
                let txtID1 = "txtduedate" + rowIndex + "txt";
                $("#tblOrder")
                  .find("input[id^='" + txtID1 + "']")
                  .focus();
              }
            );
          }
          this.setState(
            { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
            () => {

              if (this.state.isBack == 0) {
                let txtID1 = "txtduedate" + rowIndex + "txt";
                $("#tblOrder")
                  .find("input[id^='" + txtID1 + "']")
                  .focus();
              }
              // let txtID =
              //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
              //   rowIndex +
              //   "ddl";
              // $("input[class^='" + txtID + "']").focus();
              // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
              // $("input[class^='" + txtID + "']").focus();
              //   let txtID = "txtpartno" + rowIndex + "txt";
              // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
            }
          );
        }
        else {
       console.log("ppp");
          // console.log("handle seleted " + id);
          // let txtID1= "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
          //  let pname=  $("input[class^='" + txtID1 + "']").val();

          setTimeout(() => {
            // orderData[rowIndex].partname = this.state.partnamevalue;
            orderData[rowIndex].partname = orderData[rowIndex].partname;
            orderData[rowIndex].productid = 0;
            // orderData[rowIndex].partNo = orderData[rowIndex].partNo;
            orderData[rowIndex].partNo = this.state.partnamevalue;
            orderData[rowIndex].unitPrice = 0;
            orderData[rowIndex].unit = "";
            orderData[rowIndex].jobDesc = "";

            let objPartname: any = {};
            // objPartname.partname = this.state.partnamevalue;
            objPartname.partname = orderData[rowIndex].partname;
            objPartname.label = this.state.partnamevalue;;
            objPartname.id = 0;
            objPartname.partno = orderData[rowIndex].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = "";
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";
            defaultPartname.push(objPartname);
            // productList.push(objPartname);

            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = defaultPartname;
            this.setState(
              { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
              () => {

                let txtID =
                  "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                $("#tblOrder").find("input[class^='" + txtID + "']").focus();
                let txtdesc = $("#tblOrder").find("input[class^='" + txtID + "']") as any;  //$('.partname0ddl')

                if (this.state.pstart > 0 && this.state.pend > 0) {
                  //txtdesc.get(0).setSelectionRange(this.state.pstart-1, this.state.pend-1);
                  let input = txtdesc.get(0);
                  if (input.setSelectionRange) {
                    input.setSelectionRange(this.state.pstart, this.state.pend);
                  }
                  // For older browsers
                  else if (input.createTextRange) {
                    var range = input.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', this.state.pend);
                    range.moveStart('character', this.state.pstart);
                    range.select();
                  }

                } else {
                  let input = txtdesc.get(0);

                  if (input.setSelectionRange) {
                    input.setSelectionRange(0, 0);
                  } else if (input.createTextRange) {
                    // Older browsers
                    let range = input.createTextRange();
                    range.collapse(true);
                    range.moveStart('character', 0);
                    range.select();
                  }

                }
                //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                // $("input[class^='" + txtID + "']").focus();
                // let txtID =
                //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
                //   rowIndex +
                //   "ddl";
                // $("input[class^='" + txtID + "']").focus();
                // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
                // $("input[class^='" + txtID + "']").focus();
                //   let txtID = "txtpartno" + rowIndex + "txt";
                // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
              }
            );
          }, 5);
        }

        //  let id = "txtpartno" + rowIndex + "txt";

      }else if (controlID === 2) {
        if (id.length > 0) {
          if (id[0].id > 0) {
            orderData[rowIndex].unit =  id[0].selectitem;


            let objPartname: any = {};
            objPartname.itemName =  id[0].selectitem;
            objPartname.label = id[0].selectitem;
            objPartname.id = id[0].id;
            defaultPartname.push(objPartname);
            orderData[rowIndex].defaultunitname = defaultPartname;

          } else {
            orderData[rowIndex].unit = id[0].label;

              let objPartname: any = {};
              objPartname.itemName = id[0].label;
              objPartname.label = id[0].label;
              objPartname.id = 0;
              defaultPartname.push(objPartname);
              unitList.push(objPartname); 
              orderData[rowIndex].defaulunitname =  defaultPartname;

          }
        } else {

          orderData[rowIndex].unit = "";

          let objPartname: any = {};
          objPartname.itemName = "";
          objPartname.label = "";
          objPartname.id = 0;
          defaultPartname.push(objPartname);
          orderData[rowIndex].defaultunitname = id;

        }

        this.setState(
          { orderData, unitList, isStateChanged },
          () => {
            let txtID = "txtitemDesc" + rowIndex + "txt";
            $("#tblAdditionalMaterialItems").find("input[id^='" + txtID + "']").focus();
          });


      }

    }
  };




  ShowModal(partid, partno, partname, id) {
    if (id == 0 || id == null) {
     
      this.setState({ 
        detatilselectedid: id,
        selectedpart: partno  + " - " + partname.split('\n')[0]   ,
        selectedpartno: partno,
        selectedpartname: partname,

        unsave: true, 
        isSaveSpinner: false });

    }
    else {
      // this.calculateTotals();
      let qoSetup: any = [];


      let updatedQuotations: any = [];

     
      updatedQuotations = this.state.priceBreakupSetup.filter(item => item.partId === partid && item.itemName!="" && item.detailId === id) ;

      this.setState({
        selectedpartid: partid,
        detatilselectedid: id,
        selectedpart: partno  + " - " + partname.split('\n')[0]   ,
        selectedpartno: partno,
        selectedpartname: partname,
        qoSetup: updatedQuotations,

        showBreakdown: true
      }, () => {
        this.calculateTotals();



      });




    }
  }

  onInputChange = (e: any, id: any, control: any) => {

  console.log("uooo",e);
    this.setState({ partnamevalue: e });
  };

   handleOutsideClickForAdditionalItemsUnit = (rowIndex: any, e: any) => {

      let btnId = "unit" + rowIndex + "btn";
      let id = "unit" + rowIndex + "ddl";
      let relatedTargetID = e.relatedTarget?.id;

      let defaultitemname: any = [];
      let unitList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.unitList))
      );

      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );

      orderData[rowIndex].unit = e.target.value;



      if (e.target.value != "") {
        let objPartname: any = {};
        objPartname.itemName = e.target.value;
        objPartname.label = e.target.value;
        objPartname.id = 0;
        defaultitemname.push(objPartname);
        // unitList.push(objPartname);




        orderData[rowIndex].defaultunitname = defaultitemname;

        this.setState({ orderData, unitList }, () => {


        });
      }
      else {

        this.setState({ additionalMaterialItems: [] }, () =>
          this.setState({ orderData }, () => {
          })
        );
      }

      $("#tblOrder")
        .find("button[id^='" + btnId + "']")
        .css("display", "none");
      $("#tblOrder")
        .find("div[id^='" + id + "']")
        .css("display", "none");
    };
 
  handleOutsideClick = (rowIndex: any, e: any) => {



    //let responsive = "table-responsiveadd" ;
    let isStateChanged: any;
    isStateChanged = true;
    // $("#order").addClass("table-responsive");
    let btnId = "partname" + rowIndex + "btn";
    let id = "partname" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;
    let relatedTargettagName = e.relatedTarget?.tagName;

    let orderDatan = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    let defaultPartnamen: any = [];
    let productListn = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.productList))
    );

    let maxValueOfRow = Math.max(...productListn.map((o) => o.id), 0);
    let len = productListn.length;
    let maxRno = maxValueOfRow;

    if (e.target.value != "") {
      let objPartnamen: any = {};
      objPartnamen.id = Number(maxRno) + 1;
      // objPartnamen.partno = orderDatan[rowIndex].partNo;
      // objPartnamen.partname = e.target.value;
      objPartnamen.partno = e.target.value;
      objPartnamen.partname = orderDatan[rowIndex].partname;
      //objPartnamen.label =e.target.value;

      objPartnamen.tenantid = 0;
      objPartnamen.unit = "";
      objPartnamen.unitPrice = 0;
      objPartnamen.noofday = null;
      objPartnamen.pdescription = "";
      objPartnamen.label = e.target.value;


      if (e.target.value != "") {

        let partname2: any = productListn.filter(
          (x) => x.partno == e.target.value
        );
        if (partname2.length > 0) {
          // if (partname2[0].partname == e.target.value && partname2[0].partNo == orderDatan[rowIndex].partNo) { }
          if (partname2[0].partname == orderDatan[rowIndex].partname && partname2[0].partNo == e.target.value) { }
          else {
            defaultPartnamen.push(objPartnamen);
            productListn.push(objPartnamen);
          }
        } else {
          defaultPartnamen.push(objPartnamen);
          productListn.push(objPartnamen);
        }

      }
      orderDatan[rowIndex].productid = objPartnamen;
      orderDatan[rowIndex].partNo = e.target.value;
      orderDatan[rowIndex].defaultPartname = defaultPartnamen;

      //element.defaultPartname = defaultPartname;

      this.setState(
        { orderData: [], defaultPartname: [], productList: [] },
        () => {
          this.setState({
            orderData: orderDatan,
            defaultPartname: defaultPartnamen,
            productList: productListn,
            isStateChanged
          });

          // setTimeout(() => {

          //   let txtID1 = "txtduedate" + rowIndex + "txt";
          //        $("input[id^='" + txtID1 + "']").focus();
          // }, 50);
        }
      );

      // console.log(this.state.orderData);

      // console.log(this.state.productList);
    } else {
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      this.setState({ orderData: [] }, () =>
        this.setState({ orderData }, () => {
          // setTimeout(() => {

          //   let txtID1 = "txtduedate" + rowIndex + "txt";
          //       $("#tblOrder")
          //         .find("input[id^='" + txtID1 + "']")
          //         .focus();
          // }, 50);

        })
      );
    }

    $("#tblOrder")
      .find("button[id^='" + btnId + "']")
      .css("display", "block");
    $("#tblOrder")
      .find("div[id^='" + id + "']")
      .css("display", "none");
    setTimeout(() => {
      if (relatedTargetID === undefined) {
        // setTimeout(() => {

        //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //       $("#tblOrder")
        //         .find("input[id^='" + txtID1 + "']")
        //         .focus();
        // }, 50);

      } else if (
        relatedTargetID ===
        "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl"
      ) {
        let txtID1 =
          "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
          rowIndex +
          "ddl";
        $("#tblOrder")
          .find("input[class^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtpartno" + rowIndex + "txt") {
        let txtID1 = "txtpartno" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtduedate" + rowIndex + "txt") {
        let txtID1 = "txtduedate" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtdescription" + rowIndex + "txt") {
        let txtID1 = "txtdescription" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtunit" + rowIndex + "txt") {
        let txtID1 = "txtunit" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtqty" + rowIndex + "txt") {
        let txtID1 = "txtqty" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtunitprice" + rowIndex + "txt") {
        let txtID1 = "txtunitprice" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtdiscount" + rowIndex + "txt") {
        let txtID1 = "txtdiscount" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txttotal" + rowIndex + "txt") {
        let txtID1 = "txttotal" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      }

    }, 50);
  };


  // updateStateblur = (e: any, index: any, type: any, txtID) => {
  //   if (type === "partNo") {
  //     let txtID =
  //     "rbt-input-main form-control rbt-input form-control form-control-sm partname" + index + "ddl";

  //       $("input[class^='" + txtID + "']").focus();

  //   }
  // };
  updateStateblur = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {

      // let responsive = "table-responsiveadd" ;
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );


      if (type === "partNo") {
        e.preventDefault();

        let productList = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.productList))
        );

        if (this.state.productList.length == undefined || this.state.productList.length == 0) {

          let requestlist = { ...this.state.requestlist };

          requestlist.customerid = this.state.formData.CustomerID;



          ProductService.GetProductOrderlist(requestlist)
            .then(async (result: any | null) => {
              if (result !== null) {
                this.setState({ orderData: [] }, () => {
                  this.setState(
                    {
                      orderData: orderData,
                      productList: result

                    },
                    () => {
                      let partname: any = this.state.productList.filter(
                        (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
                      );
                      if (partname.length > 0) {



                        let defaultPartname: any = [];
                        let objPartname: any = {};
                        objPartname.partname = partname[0].partname;
                        objPartname.label = partname[0].partname;
                        objPartname.id = partname[0].productid;

                        objPartname.partno = partname[0].partNo;

                        objPartname.tenantid = 0;
                        objPartname.unit = partname[0].unit;
                        objPartname.unitPrice = partname[0].unitPrice;
                        objPartname.noofday = null;
                        objPartname.jobDesc = partname[0].jobDesc;

                        defaultPartname.push(objPartname);

                        orderData[index].defaultPartname = defaultPartname;

                        orderData[index].partname = partname[0].partname;

                        if (partname[0].partname != "") {
                          orderData[index].isdisabled = true;
                        }
                        // alert(partname[0].partname);
                      }
                      else {
                        let defaultPartname: any = [];
                        let objPartname: any = {};
                        objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
                        objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
                        objPartname.id = 0;

                        objPartname.partno = e.target.value;

                        objPartname.tenantid = 0;
                        objPartname.unit = 0;
                        objPartname.unitPrice = 0;
                        objPartname.noofday = null;
                        objPartname.jobDesc = "";



                        if (orderData[index].partname != "" && e.target.value != "") {
                          let partname1: any = productList.filter(
                            (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
                          );
                          if (partname1.length > 0) {
                            if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
                            else {
                              defaultPartname.push(objPartname);

                              productList.push(objPartname);
                            }
                          }
                          else {
                            defaultPartname.push(objPartname);

                            productList.push(objPartname);
                          }
                        }
                        orderData[index].defaultPartname = defaultPartname;
                        // orderData[index].isdisabled = false;
                        //  orderData[index].partname = "";
                      }
                    }
                  );
                });
              }
              resolve();
            })
            .catch((error) => {
              this.setState({ isSpinner: false });
              reject();
            });
        }
        else {
          let partname: any = this.state.productList.filter(
            (x) => x.partno == e.target.value
          );
          if (partname.length > 0) {



            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = partname[0].partname;
            objPartname.label = partname[0].partname;
            objPartname.id = partname[0].productid;

            objPartname.partno = partname[0].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = partname[0].unit;
            objPartname.unitPrice = partname[0].unitPrice;
            objPartname.noofday = null;
            objPartname.jobDesc = partname[0].jobDesc;

            defaultPartname.push(objPartname);

            orderData[index].defaultPartname = defaultPartname;

            orderData[index].partname = partname[0].partname;

            // if (partname[0].partname != "") {
            //   orderData[index].isdisabled = true;
            // }
            // alert(partname[0].partname);
          }
          else {
            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
            objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
            objPartname.id = 0;

            objPartname.partno = e.target.value;

            objPartname.tenantid = 0;
            objPartname.unit = 0;
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";


            if (orderData[index].partname != "" && e.target.value != "") {
              let partname1: any = productList.filter(
                (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
              );
              if (partname1.length > 0) {
                if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
                else {
                  defaultPartname.push(objPartname);

                  productList.push(objPartname);
                }
              }
              else {
                defaultPartname.push(objPartname);

                productList.push(objPartname);

              }
            }
            orderData[index].defaultPartname = defaultPartname;
            //orderData[index].isdisabled = false;
            //orderData[index].partname = orderData[index].partname;
          }

        }



        orderData[index].partNo = e.target.value;

        let partname: any = this.state.productList.filter(
          (x) => x.partno == e.target.value
        );
        if (partname.length > 0) {



          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = partname[0].partname;
          objPartname.label = partname[0].partname;
          objPartname.id = partname[0].productid;

          objPartname.partno = partname[0].partNo;

          objPartname.tenantid = 0;
          objPartname.unit = partname[0].unit;
          objPartname.unitPrice = partname[0].unitPrice;
          objPartname.noofday = null;
          objPartname.jobDesc = partname[0].jobDesc;

          defaultPartname.push(objPartname);

          orderData[index].defaultPartname = defaultPartname;

          orderData[index].partname = partname[0].partname;
          // if (partname[0].partname != "") {
          //   orderData[index].isdisabled = true;
          // }
          // alert(partname[0].partname);
        }
        else {
          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
          objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
          objPartname.id = 0;

          objPartname.partno = e.target.value;

          objPartname.tenantid = 0;
          objPartname.unit = 0;
          objPartname.unitPrice = 0;
          objPartname.noofday = null;
          objPartname.jobDesc = "";


          if (orderData[index].partname != "" && e.target.value != "") {
            let partname1: any = productList.filter(
              (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
            );
            if (partname1.length > 0) {
              if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
              else {
                defaultPartname.push(objPartname);

                productList.push(objPartname);
              }
            }
            else {
              defaultPartname.push(objPartname);

              productList.push(objPartname);

            }
          }
          orderData[index].defaultPartname = defaultPartname;
          // orderData[index].isdisabled = false;
          orderData[index].partname = orderData[index].partname;
        }


        this.setState(
          { orderData, productList, isStateChanged },
          () => {



            let len = this.state.orderData.length;

            let txtID =
              "rbt-input-main form-control rbt-input form-control form-control-sm partname" + (len - 1) + "ddl";
            $("#tblOrder")
              .find("input[class^='" + txtID + "']")
              .focus();


            // let txtID =
            //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
            //   index +
            //   "ddl";
            // $("input[class^='" + txtID + "']").focus();
            // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
            // $("input[class^='" + txtID + "']").focus();
            //   let txtID = "txtpartno" + rowIndex + "txt";
            // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
          }
        );
        // this.setState({ orderData, productList, isStateChanged }, () => {
        //   // $("#tblOrder")
        //   //   .find("input[id^='" + txtID + "']")
        //   //   .focus();
        //   // let txtdesc = $("#tblOrder").find(
        //   //   "input[id^='" + txtID + "']"
        //   // )[0] as any;
        //   // if (txtdesc !== null && txtdesc !== undefined) {
        //   //   txtdesc.selectionStart = start;
        //   //   txtdesc.selectionEnd = end;
        //   // }
        // });
      }

    }
  };

  // handleCOAFocus = (ddlID, rowIndex) => {
  //   let orderData = Object.assign(
  //     [],
  //     JSON.parse(JSON.stringify(this.state.orderData))
  //   );

  //   this.setState({ orderData: [] }, () =>
  //     this.setState({ orderData }, () => {
  //       $("input[class^='" + ddlID + "']").focus();
  //     })
  //   );
  // };

  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {

    let orderData = Object.assign([], JSON.parse(JSON.stringify(this.state.orderData)));

    this.setState({ orderData: [] }, () => this.setState({ orderData }, () => {
      $("input[class^='" + ddlID + "']").focus();
    }));
    // $("#tblSplit").find("button[id^='" + btnID + "']").css("display", 'none');
    // $("#tblSplit").find("div[id^='" + txtID + "']").css("display", 'block');

  };
  Previoustransactions() {
    this.setState((prevState) => ({
      isPreviousTransactions: !prevState.isPreviousTransactions,
    }));

    let requestlistprev = { ...this.state.requestlistprev };
    //requestlistprev.recordCount = 5;
    this.GetPreviousTransactionList(requestlistprev);
    this.setState({ requestlistprev });
  }

  GetPreviousTransactionList = (requestlistprev: any) => {
    // requestlist.customerid = this.state.formData.CustomerID;

    //requestlist.tenantid = this.state.tenantid;
    let saveRequest: any = {};
    saveRequest.customerid = this.state.formData.CustomerID;
    saveRequest.tenantid = 0;
    saveRequest.recordCount = requestlistprev.recordCount;
    saveRequest.search = requestlistprev.search;
    CustomerService.GetPreviousCustomerOrder(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {

          let totalCount = 0;
          if (result.filter((x) => x.orderID != this.state.orderid).length > 0) {
            totalCount = result.filter((x) => x.orderID != this.state.orderid)[0].totalCount;
          }

          this.setState({ previousOrderData: result.filter((x) => x.orderID != this.state.orderid), totalCount: totalCount });
        }
        resolve();
      })
      .catch((error) => {
        reject();
        // this.setState({ isSaveSpinner: false});
      });
  };

  showMore = () => {

    //let requestlistprev = { ...this.state.requestlistprev };
    //requestlistprev.recordCount = Number(requestlistprev.recordCount) + 5;
    //this.loadPreviousData();

    this.setState({ displayRecordCount: (this.state.displayRecordCount + 5) });
  };

  loadPreviousData() {

    let requestlistprev = { ...this.state.requestlistprev };
    let loadrecord = requestlistprev.recordCount;
    //requestlistprev.recordCount = Number(requestlistprev.recordCount) + 5;
    requestlistprev.search = this.state.searchPreviousData;
    //if (Number(loadrecord) <= Number(this.state.totalCount) || this.state.searchPreviousData != '') {
    this.GetPreviousTransactionList(requestlistprev);
    this.setState({ requestlistprev });
    // }
    //    else {
    //        toast.error("No previous order exist.", {
    //          position: toast.POSITION.BOTTOM_RIGHT,
    //           containerId: "Customerorderslideout",
    //        });
    //      }
  }

  AddedRow = (e) => {
    this.setState({ isSaveSpinner: false });
    this.setState({ Isadded: true });
    this.setState({ isDuplicate: false });
    this.handleRowSelection(e, this.state.rowData, this.state.Orderid);
  };
  CancelRow = (e) => {
    this.setState({ isSaveSpinner: false });
    this.setState({ Isadded: false });
    this.setState({ isDuplicate: false });
  };

  Cancelunsave = (e) => {

    this.setState({ unsave: false });
  };  
  Cancelunsave1 = (e) => {

    this.setState({ isattachFile: false });
  };

  handleRowSelectionCheck = (e, rowData, Orderid, isAll) => {
    let orderData: any = [];

    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          if (rowData === index) {
            let orderDatacheck = this.state.orderData.filter(
              (x) =>
                x.productid === element.productid ||
                x.partname === element.partname
            );
            if (orderDatacheck.length > 0) {
              this.setState({
                isDuplicate: true,
                Isadded: false,
                Orderid: Orderid,
                rowData: rowData,
              });
            } else {
              if (isAll === "all") {
                this.handleRowSelectionn(e, 0, Orderid);
              } else {
                this.handleRowSelection(e, rowData, Orderid);
              }
            }
          }
        });
      }
    }
  };

  handleRowSelectionCheckAll = (e, Orderid) => {
    if (this != undefined) {
      let prevorderid = this.state.prevOrderidselected;

      let orderArray: any = [];
      let previousOrderData: any = [];
      previousOrderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.previousOrderData))
      );
      orderArray = previousOrderData.filter(
        (x) => x.orderID === prevorderid && x.mainType == 2
      );

      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          //  this.handleRowSelectionn(e,0,prevorderid);
          this.handleRowSelectionCheck(e, index, prevorderid, "all");
        });
      } else {
        previousOrderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.previousOrderData))
        );
      }
      this.setState({ previousOrderData: previousOrderData });
    }
  };

  handleRowSelection = (e, rowData, Orderid) => {

    let orderData: any = [];
    let defaultPartname: any = [];
    let isStateChanged = true;
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {

          if (rowData === index) {

            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = element.partname;
            objPartname.label = element.partname;
            objPartname.id = element.productid;

            objPartname.partno = element.partNo;

            objPartname.tenantid = 0;
            objPartname.unit = element.unit;
            objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
            objPartname.noofday = null;
            objPartname.jobDesc = element.partname;
            // element.jobDesc;

            defaultPartname.push(objPartname);
            element.defaultPartname = defaultPartname;

            element.itemNo = index + 1;
            element.dueDate =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
            element.qtyOrdered = 0;

            orderData.push(element);
            let orderlistItem: any = [];
            //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
            orderlistItem.itemNo = index + 1;
            orderlistItem.partname = element.partname;
            orderlistItem.partno = element.partNo;
            orderlistItem.dueDate =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
            //element.dueDate;
            orderlistItem.jobDesc = element.partname;
            // element.jobDesc;
            orderlistItem.qtyOrdered = 0;
            //element.qtyOrdered;
            orderlistItem.unit = element.unit;
            orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
            orderlistItem.discount = Utils.currencyFormat(element.discount);
            orderlistItem.total = element.total;
            orderlistItem.productid = element.productid;
            orderlist.push(orderlistItem);
          }
        });
      } else {
        orderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.orderData))
        );
      }

      this.setState({ orderData: orderData, defaultPartname, isStateChanged });

      this.setState({ orderData: [] }, () => {
        const orderDataNewc = orderData
          .filter((item) => item.partname !== "")
          .map((item, index) => {
            item.itemNo = index + 1;

            return item;
          });

        this.setState(
          {
            orderData: orderDataNewc,
          },
          () => { }
        );
      });
    }
  };

  handleRowSelectionn = (e, rowData, Orderid) => {

    let orderData: any = [];
    let defaultPartname: any = [];
    let isStateChanged = true;
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {

          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = element.partname;
          objPartname.label = element.partname;
          objPartname.id = element.productid;

          objPartname.partno = element.partNo;

          objPartname.tenantid = 0;
          objPartname.unit = element.unit;
          objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
          objPartname.noofday = null;
          objPartname.jobDesc = element.partname;
          // element.jobDesc;

          defaultPartname.push(objPartname);
          element.defaultPartname = defaultPartname;

          element.itemNo = index + 1;
          element.dueDate =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
          element.qtyOrdered = 0;

          orderData.push(element);
          let orderlistItem: any = [];
          //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
          orderlistItem.itemNo = index + 1;
          orderlistItem.partname = element.partname;
          orderlistItem.partno = element.partNo;
          orderlistItem.dueDate =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
          //element.dueDate;
          orderlistItem.jobDesc =  element.partname;
          //element.jobDesc;
          orderlistItem.qtyOrdered = 0;
          //element.qtyOrdered;
          orderlistItem.unit = element.unit;
          orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
          orderlistItem.discount = Utils.currencyFormat(element.discount);
          orderlistItem.total = element.total;
          orderlistItem.productid = element.productid;
          orderlist.push(orderlistItem);
        });
      } else {
        orderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.orderData))
        );
      }

      this.setState({ orderData: orderData, defaultPartname, isStateChanged });

      this.setState({ orderData: [] }, () => {
        const orderDataNewc = orderData
          .filter((item) => item.partname !== "")
          .map((item, index) => {
            item.itemNo = index + 1;

            return item;
          });

        this.setState(
          {
            orderData: orderDataNewc,
          },
          () => { }
        );
      });
    }
  };

  handleRowSelectionAll = (e, rowIndex: any) => {
    if (this != undefined) {
      let prevorderid = this.state.prevOrderidselected;

      let orderArray: any = [];
      let previousOrderData: any = [];
      previousOrderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.previousOrderData))
      );
      orderArray = previousOrderData.filter(
        (x) => x.orderID === prevorderid && x.mainType == 2
      );

      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          this.handleRowSelectionn(e, 0, prevorderid);
        });
      } else {
        previousOrderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.previousOrderData))
        );
      }
      this.setState({ previousOrderData: previousOrderData });
    }
  };
  OpenViewer() {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        singleView:false,
        isOpenViewer: !prevState.isOpenViewer,
        fileSelect:
          this.state.savedfiles.length > 0
            ? this.state.savedfiles[0]
            : this.state.newSelectfiles[0],
        isMapped: "No",
        isExtractOption: false,
      }),
      () => {
        this.setState({ defaultView: "doc-view" });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  }

  OpenViewerSingle(index:any) {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        singleView:true,
        singleViewFiles: [this.state.savedfiles[index]],
        fileSelect:
          this.state.savedfiles.length > 0
            ? this.state.savedfiles[0]
            : this.state.newSelectfiles[0],
        isMapped: "No",
        isExtractOption: false,
      }),
      () => {
        this.setState({ defaultView: "doc-view" });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  }

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      //this.setState({ showSlideout: true ,orderid:row.orderID
      // });
      this.handleRowSelectionCheck(e, rowIndex, row.orderID, "no");
    },
  };
  hideBulkselect() {
    this.setState({
      bulkSelect: false,
      chkIds: [],
      selectedChk: [],
      isMapped: "No",
    });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  }
  setTotalPages = (totalpage) => {
    let isextractShow =
      this.state.savedfiles.length === 1 && totalpage === 1 ? true : false;
    this.setState({ isextractShow, isExtractOption: false });
  };
  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let request: any = {};
      request = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.state.formData))
      );
      let masg = "";

      masg = "Are you sure you want to delete this Attachment?";

      confirmAlert({
        title: "Delete Attachment",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.isDeleteattachment(file),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    } else if(eventKey === "view"){
      this.OpenViewerSingle(index);
     }
  };

  isDeleteattachment(file) {
    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    this.handleFileDelete(newfiles, file);
  }

  handleButtonClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };
  
  ShowJobModal(itemno, productid, partname, partNo, qtyOrdered, poNumber, dueDate, jobDesc, id, jobid, leadTime, rNo) {

    // let requestlist = { ...this.state.requestlist };
    //this.props.GetTempateType(requestlist);
    //this.props.dropdownbind();

    this.setState({
      showjobrModal: true,
      itemNo: itemno, CustomerPoNumber: this.state.formData.CustomerPoNumber, poNumber: poNumber,
      orderid: this.state.orderid, productid: productid, partname: partname, partNo: partNo, qtyOrdered: qtyOrdered, isSpinner: false,
      selectedCustomer: this.state.formData.CustomerName + " (" + this.state.formData.customercode + ")"
      , orderdate: this.state.formData.OrderDate, dueDate: dueDate, jobDesc: jobDesc, id: id, jobid: jobid, leadTime: leadTime, rNo: rNo
    }, () => {

    });


  }



  isDeleteAttachment(file) {
    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    // this.handleFileAttachement(newfiles, file);
  }
  handleFileDelete(newfiles, file) {
    let request: any = {};
    request.fileUniqueno = file.fileUniqueno;
    request.orderid = this.state.orderid;

    this.handleDeleteFileFromDb(request, newfiles, 2);
  }
  handleDeleteFileFromDb(request, newfiles, id) {
    let fileno = request.fileNo;
    CustomerService.DeleteQuotationUploadedFile(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false });
          this.GetorderEntryColoumn();

        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }
  downloadTranactionFile = (file: any) => {
    CustomerService.DownloadQutationTranactionFile(file)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ isSaveSpinner: false });
      });
  };
  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    // console.log("updateZoom-" + updateZoom);
    this.setState({ currentZoom: updateZoom });
  };
  handleAllCheckbox(event) {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  }




  onFileChange = (event: any, mode) => {

    // 
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }     
      this.onDrop(newfiles, mode);

    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }

      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  onDrop = (filelist: any, mode: any) => {
    let size = this.state.fileSize; //5242880//5MB
    let newfiles: any = [];
    let files: any = [];
    let isReturn = true;
    let filestext = "";
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSpinner: false});
      return false;
    }
    let isInvalidFile = false;
    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
        files.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSpinner: false});
      return false;
    }

    this.setState(
      {
        files,
        newSelectfiles: newfiles,
        isSave: true,
        ispopupshow: false,
        isSpinner: true,
      },
      () => {
        if (files.length > 0) {
        if(this.state.orderid > 0){
          this.handleSaveFiles(files);
        }else{
        this.setState({isSpinner: false,isattachFile:true});
        }
        }
      }
    );
  };

closeOrder =  () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.orderid = this.state.orderid;
    CustomerService.CloseQuotation(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut();

          toast.success("Quotation has been closed.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };


  deleteOrder = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.orderid = this.state.orderid;
    CustomerService.DeleteQuotation(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut();

          toast.success("Quotation has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };


  moreActions = (eventKey: any) => {

    if (eventKey == "DuplicateQuotation") {

      let orderData = this.state.orderData;
      let start: any = new Date(this.state.formData.OrderDate);
      this.state.formData.OrderDate =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));

      this.state.formData.OrderID = 0;

      this.state.formData.OldOrderID = this.state.orderid;
      orderData.forEach(element => {
        let end: any = new Date(element.dueDate);
        let differenceInTime: any = end - start;
        element.dueDate = new Date(new Date().getTime() + differenceInTime);

      });


      this.setState({ orderData: [], orderid: 0, orderType: 'Duplicate ' }, () => {
        this.setState({ orderData: orderData, isStateChanged: true }, () => { });
      });
    }


    if (eventKey == "DuplicateOrder1" || eventKey == "DuplicateOrder2") {
      this.checkorder("order", false, true,eventKey == "DuplicateOrder1" ? true : false);
    }

    if (eventKey == "Delete") {

      // this.deleteOrder();

      let masg = "";

      masg = "Are you sure you want to delete this quotation?";

      confirmAlert({
        title: "Delete quotation",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.deleteOrder(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });

    }

    if (eventKey == "print") {

      // this.printItem();
       this.saveOrderfinal("order", false, false, true);
    }

    if(eventKey == "Close"){
     this.closeOrder();
    }

   if (eventKey == "Email") {
        this.setState({showMailPanel: true});
    }
  };

    cancelSendMail = () => {
    this.setState({ showMailPanel: false });
  };


     handleAttachment = (event) => {
  this.setState({
    isAttachments: event.target.checked,
  });
};


sendMail = () => {

    this.setState({ showMailPanel: false });
    this.SendMailToVendor();
  };

  base64ToFile = (base64String: string, fileName: string): File => {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

    SendMailToVendor = () => {
      let request: any = {};
      request.orderid = this.state.orderid;
      request.tenantid = 0;
  
      //let selectedVendor = this.state.customerList.filter((x) => x.vendor_id === this.state.formData.CustomerID); 
      if (this.state.mailContent.MailTo == '')
        return;
  
      
        const files = this.state.isAttachments
      ? (this.state.savedfiles || []).map(f => this.base64ToFile(f.fileCode, f.fileName))
      : [];
  
      let item: any = {};
      item.mailTo = this.state.mailContent.MailTo; //selectedVendor[0].email;
      item.mailCC = this.state.mailContent.CC;
      // item.subject = 'Vendor Order';
      item.subject =  this.state.mailContent.subject;
      item.mailBody = this.state.mailContent.Message; //3'Please find the attachment for order detail.';
      item.isBodyHtml = true;
      item.sendFrom = '';
      item.mailFrom = '';
  
    const formData = new FormData();
    formData.append('mailTo', this.state.mailContent.MailTo);
    formData.append('mailCC', this.state.mailContent.CC);
    formData.append('subject', this.state.mailContent.subject);
    formData.append('mailBody', this.state.mailContent.Message);
    formData.append('isBodyHtml', 'true');
    formData.append('sendFrom', '');
    formData.append('mailFrom', '');
  
    files.forEach(file => {
      formData.append('files', file);
    });
  
      this.setState({ isSpinner: true });
      VendorService.SendMailToCustomer(request, formData)
        .then(async (result: any | null) => {
          //this.HidecloseSlideOut();
          toast.success("Email sent to customer.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
  
          this.setState({ showAfterSaveModelPopup: false, isSpinner: false, },()=>{
              //  VendorService.VendorEmailTrack({orderid:this.state.vendororderid})
              //     .then(async (result: any[] | null) => {
              //       if (result != null) {
              //        this.setState({sentDate:result});
              //       }
              //       resolve();
              //     })
              //     .catch((err: any) => {
              //       toast.error(`Server Error, ${err}`);
              //       reject();
              //     });
          });
          resolve();
        })
        .catch((error) => {
          reject();
          this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
        });
    };

  printItem = () => {
    let saveRequest: any = {};
    saveRequest.orderid = this.state.orderid;
    // saveRequest.quotationBreakupPrice=this.state.quotationBreakupPrice;
    //let selecteddata : any ="";
    let selecteddata: any = [];
    let ids = "";
    let quotationBreakupPrice = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.quotationBreakupPrice))
    );
    if (quotationBreakupPrice.length > 0) {
      quotationBreakupPrice.forEach((element: any, index: any) => {
        
        let item: any = {};
        if (element.selected == true) {
          if (ids == "") {
            ids = element.id;
          }
          else {
            ids = ids + "," + element.id;
          }
          item.Id = element.id;

          selecteddata.push(item);
        }
      });
    };
    // this.state.formData.selecteddata = selecteddata;
    // let quotationbreakup: any = this.state.quotationBreakupPrice.map(item => ({
    //   ...item,
    //   price:  Utils.removecurrencyFormat(item.price)

    // }));
    //this.state.formData.quotationBreakupPrice=selecteddata;
    saveRequest.selectedData = ids;
    // Object.assign(
    //   [],
    //   JSON.parse(JSON.stringify(selecteddata))
    // );
    //quotationbreakup.filter(item=>item.itemName!='Quantity');
    //saveRequest.selecteddata = selecteddata;
    //saveRequest = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    
    //saveRequest.tenantid = 0;
    this.setState({ isSpinner: true });

    CustomerService.GetQuotationPDF(saveRequest)
      .then(async (result: any | null) => {
        //this.HidecloseSlideOut();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
      });
  };


  handleOnSelect = (row, isSelect) => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let listItem = orderData.filter(
      (x) => x.itemNo === row.itemNo
    );

    listItem[0].selected = isSelect;

    this.setState({ orderData: orderData });


  };


  handleOnSelectPrice = (row, isSelect) => {

    let quotationBreakupPrice = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.quotationBreakupPrice))
    );

    let listItem = quotationBreakupPrice.filter(
      (x) => x.id === row.id
    );

    listItem[0].selected = isSelect;

    this.setState({ quotationBreakupPrice: quotationBreakupPrice });


  };

  handleOnSelectAllPrice = (isSelect, rows) => {

    const ids = rows.map(r => r.id);

    let quotationBreakupPrice = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.quotationBreakupPrice))
    );

    let listItems = quotationBreakupPrice.filter(
      (x) => ids.includes(x.id)
    );

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

    this.setState({ quotationBreakupPrice: quotationBreakupPrice });
  };


  handleOnSelectAll = (isSelect, rows) => {

    const ids = rows.map(r => r.itemNo);

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let listItems = orderData.filter(
      (x) => ids.includes(x.itemNo)
    );

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

    this.setState({ orderData: orderData });
  };

  handleChangeBuyer = (event: any) => {
    let Defaultselected: any = [];
    let formData = { ...this.state.formData };
    if (event.length > 0) {


      let objData: any = {};

      objData.id = event[0].id;
      objData.name = event[0].name;
      Defaultselected.push(objData);

      formData.BuyerName = event[0].name;
    }

    this.setState({ Defaultselected: Defaultselected, formData: formData, isStateChanged: true });

  };


  addRow = () => {
    const { qoSetup } = this.state;

    const newRow = {
      detailId: 0,
      id: 0,
      itemName: "",
      partId: 0,
      rowId: qoSetup.length + 1,
      //qoSetup.length ? Math.max(qoSetup.map(item => item.rowId)) + 1 : 0,
      //qoSetup.length ? Math.max(qoSetup.map(item => item.id)) + 1 : 0,
      priceId: 0,

      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,

      tenantId: 0
    };
    this.setState({ qoSetup: [...qoSetup, newRow] });


  };


  calculateTotals = () => {
    const { qoSetup } = this.state;
if(qoSetup.length>0)
{

// debugger;



    const totalsExpand = {
      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,
      partId: qoSetup[0]?.partId || 0,
      isMatch1:false,
      isMatch2:false,
      isMatch3:false,
      isMatch4:false,
      isMatch5:false,

    };

    const totals = {
      qty1: 0,
      qty2: 0,
      qty3: 0,
      qty4: 0,
      qty5: 0,
      partId: qoSetup[0]?.partId || 0
    };
    //console.log("beforetotals", qoSetup);

    // Accumulate totals for each quantity field
    qoSetup.filter(x => x.itemName != "Quantity").forEach(item => {

      totals.qty1 += parseFloat(Utils.removecurrencyFormat(item.qty1)) || 0;
      totals.qty2 += parseFloat(Utils.removecurrencyFormat(item.qty2)) || 0;
      totals.qty3 += parseFloat(Utils.removecurrencyFormat(item.qty3)) || 0;
      totals.qty4 += parseFloat(Utils.removecurrencyFormat(item.qty4)) || 0;
      totals.qty5 += parseFloat(Utils.removecurrencyFormat(item.qty5)) || 0;
    });


    
const total1qty=this.state.orderData.filter(item => item.partname == this.state.selectedpartname && item.partNo == this.state.selectedpartno);


const totalBreakTotal1qty = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid);
    const total1 = this.state.orderData.filter(item => item.partname == this.state.selectedpartname && item.partNo == this.state.selectedpartno && item.id == this.state.detatilselectedid ).reduce((sum, obj) => {


      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.unitPrice));
      return sum + currentvalue;
    }, 0);

    const total2 = this.state.quotationBreakupPrice.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid && item.srNo == 2).reduce((sum, obj) => {
      

      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.price));
      return sum + currentvalue;
    }, 0);
    const total3 = this.state.quotationBreakupPrice.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid && item.srNo == 3).reduce((sum, obj) => {
      

      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.price));
      return sum + currentvalue;
    }, 0);

    const total4 = this.state.quotationBreakupPrice.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid && item.srNo == 4).reduce((sum, obj) => {
      

      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.price));
      return sum + currentvalue;
    }, 0);

    const total5 = this.state.quotationBreakupPrice.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid && item.srNo == 5).reduce((sum, obj) => {
      

      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.price));
      return sum + currentvalue;
    }, 0);
    


    totalsExpand.qty1 += parseFloat(Utils.removecurrencyFormat(total1)) || 0;
    totalsExpand.qty2 += parseFloat(Utils.removecurrencyFormat(total2)) || 0;
    totalsExpand.qty3 += parseFloat(Utils.removecurrencyFormat(total3)) || 0;
    totalsExpand.qty4 += parseFloat(Utils.removecurrencyFormat(total4)) || 0;
    totalsExpand.qty5 += parseFloat(Utils.removecurrencyFormat(total5)) || 0;

    totalsExpand.isMatch1= totalsExpand.qty1 == totals.qty1 ? true : false;
    totalsExpand.isMatch2= totalsExpand.qty2 == totals.qty2 ? true : false; 
    totalsExpand.isMatch3= totalsExpand.qty3 == totals.qty3 ? true : false;
    totalsExpand.isMatch4= totalsExpand.qty4 == totals.qty4 ? true : false;
    totalsExpand.isMatch5 = totalsExpand.qty5 == totals.qty5 ? true : false;


    const totalBreakTotal1 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty1));
      return sum + currentvalue;
    }, 0);


    const totalBreakTotal2 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty2));
      return sum + currentvalue;
    }, 0);


    const totalBreakTotal3 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty3));
      return sum + currentvalue;
    }, 0);

    const totalBreakTotal4 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty4));
      return sum + currentvalue;
    }, 0);

    const totalBreakTotal5 = this.state.qoSetup.filter(item => item.itemName != 'Quantity' && item.partId == this.state.selectedpartid).reduce((sum, obj) => {

      
      const currentvalue = parseFloat(Utils.removecurrencyFormat(obj.qty5));
      return sum + currentvalue;
    }, 0);
    
    // let isMatch1 = totalsExpand.qty1 == totals.qty1 ? true : false;
    // let isMatch2 = totalsExpand.qty2 == totals.qty2 ? true : false;
    // let isMatch3 = totalsExpand.qty3 == totals.qty3 ? true : false;
    // let isMatch4 = totalsExpand.qty4 == totals.qty4 ? true : false;
    // let isMatch5 = totalsExpand.qty5 == totals.qty5 ? true : false;
    this.setState({ totals,totalsExpand });

    if (totalBreakTotal1 == total1 && totalBreakTotal2 == total2 && totalBreakTotal3 == total3 && totalBreakTotal4 == total4 && totalBreakTotal5 == total5) {

      this.setState({ isicon: false  });
    }
    else {

      this.setState({ isicon: true});
    }
  }
  };

  resetData = () => {



    let qoSetup = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.qoSetup))
    );



    qoSetup.forEach((items: any, index: any) => {


      if (items.itemName != "Quantity") {

        items.qty1 = 0;
        items.qty2 = 0;
        items.qty3 = 0;
        items.qty4 = 0;
        items.qty5 = 0;
      }

    });

    this.setState({ qoSetup: qoSetup, showReset: false }, () => {

      this.calculateTotals();
    }


    );

  };

  handleResetData = (isConfirmed: any) => {
    if (isConfirmed) {
      this.resetData();
    } else {
      this.setState({ showReset: false });
    }
  };

  saveData = (type) => {
  this.setState({
    showApplyPopup: true,
    pendingType: type
  });
};

  handleApplyData = (isConfirmed: any) => {
     this.setState({ showApplyPopup: false },()=>{
      this.save(this.state.pendingType, isConfirmed);
     });
      
  };


  save = (type,applyTemplate) => {
    this.setState({ isSaveSpinner: true });
    let isFormValid = true;
    let { qoSetup } = this.state;

    this.setState({ isWait: true });
    let processlistItem: any = [];

      let isQty1Available = false;
      let isQty2Available = false;
      let isQty3Available = false;
      let isQty4Available = false;
      let isQty5Available = false;

    // qoSetup.forEach((items: any, index: any) => {
    for (let index = 0; index < qoSetup.length; index++) {
        const items = qoSetup[index];
      let newIndex = index + 1;

      let item: any = {};

      if (items.itemName.trim().length != 0) {
        item.priceId = items.priceId;
        item.itemName = items.itemName;
        item.OrderBy = 0;
        item.qty1 = Utils.removecurrencyFormat(items.qty1);
        item.qty2 = Utils.removecurrencyFormat(items.qty2);
        item.qty3 = Utils.removecurrencyFormat(items.qty3);
        item.qty4 = Utils.removecurrencyFormat(items.qty4);
        item.qty5 = Utils.removecurrencyFormat(items.qty5);
        item.Status = true;
        item.OrderId = this.state.orderid;
        item.detailId = this.state.detatilselectedid;
        item.partId = this.state.selectedpartid;
        item.tenantId = items.tenantId;
        item.Type = type;


   if (item.itemName === "Quantity") {
      if (item.qty1 > 0) isQty1Available = true;
      if (item.qty2 > 0) isQty2Available = true;
      if (item.qty3 > 0) isQty3Available = true;
      if (item.qty4 > 0) isQty4Available = true;
      if (item.qty5 > 0) isQty5Available = true;
    } else {
      if (
        (item.qty1 > 0 && !isQty1Available) ||
        (item.qty2 > 0 && !isQty2Available) ||
        (item.qty3 > 0 && !isQty3Available) ||
        (item.qty4 > 0 && !isQty4Available) ||
        (item.qty5 > 0 && !isQty5Available)
      ) {
        toast.error("Qty missing in one of the columns.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        this.setState({ isSaveSpinner: false });
        isFormValid = false;
        return; 
      }
    }

        processlistItem.push(item);
      }
    };


  if (isFormValid) {
    let request:any =  {};
    request.processmaster = processlistItem;
    request.applyTemplate = applyTemplate;

    CustomerService.SavePriceBeakup(request).then(
      async (result: any | null) => {
        toast.success("Saved successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

        this.GetorderEntryColoumn();

        this.setState({ showBreakdown: type == 0 ? true : false, isSaveSpinner: false });
      }
    );

  }

  };


  //   saveData = () => {
  // 
  //    let qoSetup: any = [];
  //    let processlistItem: any = [];
  //     qoSetup =this.state.qoSetup.filter(item => item.partId === this.state.selectedpartid);

  //     qoSetup.forEach((element: any, index: any) => {

  //       let items: any = [];
  //     //   items.Id=0;
  //     //   items.priceId=element.priceId;
  //     //  // items.itemName=element.itemName;
  //     //   items.OrderBy=0;
  //     //   items.qty1=element.qty1;
  //     //   items.qty2=element.qty2;
  //     //   items.qty3=element.qty3;
  //     //   items.qty4=element.qty4;
  //     //   items.qty5=element.qty5;
  //     //   items.Status=true;
  //     //   items.OrderId=this.state.orderid ;
  //     //   items.detailId=element.detailId;
  //     //   items.partId=element.partId;
  //     //   items.tenantId=element.tenantId;
  //     // let newIndex = index + 1;
  //     // items.Id=newIndex;

  //     items.priceId =1;

  //     // items.OrderBy=1;


  //     // items.qty1 =10;


  //     // items.qty2 =10;


  //     // items.qty3 =10;


  //     // items.qty4 =10;


  //     // items.qty5 =10;

  //     // items.Status =10;
  //     // items.OrderId =1;
  //     // items.detailId=11;
  //     // items.partId =1;
  //     // items.tenantId =101;
  //     processlistItem.push(items);
  //     }
  //   );
  //   
  //     // let request: any = {};
  //     // this.state.formData.pricebsetupDto=qoSetuplistItem;
  //     // request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));




  //     CustomerService.SavePriceBeakup(processlistItem).then(
  //       async (result: any | null) => {

  //           let requestlist = { ...this.state.requestlist };
  //           // this.getprocessMaster(requestlist);

  //           // toast.error("Process updated",
  //           //   { position: toast.POSITION.BOTTOM_RIGHT, containerId: "userManagementHierarchy" });

  //           //   this.setState({ isSaveOpen: false ,loading: false });
  //       }
  //     );
  //     //request.PriceBreakupSetup=qoSetup;
  //     // CustomerService.SavePriceBeakup(request)
  //     // .then(async (result: any | null) => {
  //     //   resolve();
  //     // })
  //     // .catch((error) => {
  //     //   this.setState({ isSaveSpinner: false });
  //     //   reject();
  //     // });


  //     // const { quotationBreakupPrice , priceBreakupSetup, qoSetup} = this.state;
  //     //  console.log("A",priceBreakupSetup);
  //     //  console.log("B",qoSetup);

  //     // const updatedQuotationBreakupPrice = quotationBreakupPrice.map(entry => {
  //     //   let updatedEntry = { ...entry };

  //     //   switch (entry.qty) {
  //     //     case 1:
  //     //       updatedEntry.price = this.state.totals.qty1;
  //     //       break;
  //     //     case 2:
  //     //       updatedEntry.price = this.state.totals.qty2;
  //     //       break;
  //     //     case 5:
  //     //       updatedEntry.price = this.state.totals.qty3;
  //     //       break;
  //     //     case 10:
  //     //       updatedEntry.price = this.state.totals.qty4;
  //     //       break;
  //     //     default:
  //     //       updatedEntry.price = 0; 
  //     //       break;
  //     //   }

  //     //   return updatedEntry;
  //     // });
  //     this.setState({  showBreakdown:false});
  //   };

   handlePartOnSelect = (row, isSelect) => {  
    this.setState({ selectedPartId:row.id});
  };

  handleJobOnSelect = (row, isSelect) => {  
    this.setState({ selectedJobId:row.jobId,selectedPartId:row.partId});
  };


  render() {

    const { permissions } = this.props; 
    const hasEditOrderPermission = permissions && permissions['Customer Quotations'] ? permissions['Customer Quotations'].includes('Edit Quotation') : false;
    const hasAddOrderPermission = permissions && permissions['Customer Quotations'] ? permissions['Customer Quotations'].includes('Add Quotation') : false;
    const hasDeleteOrderPermission = permissions && permissions['Customer Quotations'] ? permissions['Customer Quotations'].includes('Delete Quotation') : false;
    const hasConvertOrderPermission = permissions && permissions['Customer Quotations'] ? permissions['Customer Quotations'].includes('Convert Order') : false;

    console.log("ppppp",hasDeleteOrderPermission);

    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // Log the entry and all associated details.
        console.log(entry.toJSON());
      }
    });
    
    po.observe({type: 'some-entry-type'});
    
    const { srno1, srno2, srno3, srno4 } = this.state;


    const columns = [
      // {
      //   dataField: 'partId',
      //   text: 'partid',
      //   headerStyle: { width: '50px' },
      // },
      {
        dataField: 'itemName',

        text: '',
        headerStyle: { width: '42%' },

        headerClasses: 'd-none',
        classes: 'text-start pe-4',
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtitemname" + rowIndex;
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter"
                value={row.itemName}
                onChange={(e) => this.updateState(e, rowIndex, "itemName", id)}
                //  onBlur={(e: any) => this.amountBlur(e, rowIndex, "qtyOrdered")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={(row.priceId != 0) || row.itemName == "Quantity" ? true : false}
                title=""
                
                className="form-control form-control-sm"
                style={{ fontWeight: isBold ? 'bold' : 'normal' }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty1',

        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtqty1" + rowIndex + "txt";
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Price"
                value={row.qty1}
                onChange={(e) => this.updateState(e, rowIndex, "qty1", id)}
                //  onBlur={(e: any) => this.amountBlur(e, rowIndex, "qtyOrdered")}
                onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty1")}
                onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty1")}
                onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty1")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                // disabled={  row.itemName=="Quantity" ? true:false }
                title=""
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal' }}

              />
            </div>
          );
        },


      },
      {
        dataField: 'qty2',

        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',

        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtqty2" + rowIndex + "txt";
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Price"
                value={row.qty2 == null ? 0 : row.qty2}
                onChange={(e) => this.updateState(e, rowIndex, "qty2", id)}
                onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty2")}
                onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty2")}
                onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty2")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                // disabled={  row.itemName=="Quantity" ? true:false}
                title=""
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty3',

        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtqty3" + rowIndex + "txt";
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Price"
                value={row.qty3 == null ? 0 : row.qty3}
                onChange={(e) => this.updateState(e, rowIndex, "qty3", id)}
                onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty3")}
                onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty3")}
                onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty3")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                //  disabled={  row.itemName=="Quantity"  ? true:false}
                title=""
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty4',

        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',

        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtqty4" + rowIndex + "txt";
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Price"
                value={row.qty4 == null ? 0 : row.qty4}
                onChange={(e) => this.updateState(e, rowIndex, "qty4", id)}
                onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty4")}
                onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty4")}
                onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty4")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                // disabled={  row.itemName=="Quantity"  ? true:false}
                title=""
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
              />
            </div>
          );
        },
      },

      ,
      {
        dataField: 'qty5',

        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',

        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtqty5" + rowIndex + "txt";
          let disable = this.state.formData.CustomerID == 0 ? true : false;
          let isBold = row.itemName == "Quantity" ? true :false;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Price"
                value={row.qty5 == null ? 0 : row.qty5}
                onChange={(e) => this.updateState(e, rowIndex, "qty5", id)}
                onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "qty5")}
                onBlur={(e: any) => this.amountBlur(e, rowIndex, "qty5")}
                onKeyDown={(e) => this.handleTabKeyDown(e, rowIndex, "qty5")}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                // disabled={  row.itemName=="Quantity"  ? true:false}
                title=""
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: isBold ? 'bold' : 'normal', backgroundColor: row.itemName == "Quantity" ? '#e9ecef' : '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
    ];

    const columns1 = [
      {
        dataField: 'label',
        text: '',
        headerStyle: { width: '42%' },
        headerClasses: 'd-none',
        classes: 'text-start pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `label${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                type="text"
                value="Total Price ($)"
                disabled={true}
                className="form-control form-control-sm no-border"
                style={{ fontWeight: "bold" }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty1',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty1${rowIndex}`;
        //  console.log("yooo", row.qty1);

          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty1)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold" }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty2',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty2${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty2)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty3',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty3${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty3)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty4',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty4${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty4)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
              />
            </div>
          );
        },
      },


      {
        dataField: 'qty5',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty5${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty5)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffbaba8a' }}
              />
            </div>
          );
        },
      },
    ];
    const columns2 = [
      {
        dataField: 'label',
        text: '',
        headerStyle: { width: '40%' },
        headerClasses: 'd-none',
        //classes: 'text-start pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `label${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                type="text"
                value="Quoted Price ($)"
                disabled={true}
                className="form-control form-control-sm no-border"
                style={{ fontWeight: "bold" , background:"#fff", }}
              />



            </div>
          );
        },
      },
      {
        dataField: 'qty1',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        // classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty1${rowIndex}`;
        //  console.log("yooo", row.qty1);

          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty1)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={true}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", background:"#fff", color: row.isMatch1 == true ? "Green" : "Red" }}
              />

            </div>
          );
        },
      },
      {
        dataField: 'qty2',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        // classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty2${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty2)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={true}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", background:"#fff", color: row.isMatch2 == true ? "Green" : "Red" }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty3',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        // classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty3${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty3)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={true}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold", background:"#fff", color: row.isMatch3 == true ? "Green" : "Red" }}
              />
            </div>
          );
        },
      },
      {
        dataField: 'qty4',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        //  classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty4${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty4)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={true}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold",  background:"#fff",color: row.isMatch4 == true ? "Green" : "Red" }}
              />
            </div>
          );
        },
      },


      {
        dataField: 'qty5',
        text: '',
        headerStyle: { width: '15%' },
        headerClasses: 'd-none',
        classes: 'text-end pe-4',
        formatter: (cell, row, rowIndex) => {
          let id = `totalqty5${rowIndex}`;
          return (
            <div>
              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter Total"
                value={Utils.currencyFormat(row.qty5)}
                autoComplete="off"
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                disabled={true}
                className="form-control form-control-sm"
                style={{ textAlign: 'right', fontWeight: "bold",  background:"#fff",color: row.isMatch5 == true ? "Green" : "Red" }}
              />
            </div>
          );
        },
      },
    ];


    const {
      data,
      showjobrModal,
      selected,
    } = this.state;

    const expandSplitRow = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderItemTableChild(row, rowIndex),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };

    const renderItemTableChild = (mainrow, rowIndex) => {



      let splitDetail: any = [];


      
      
      splitDetail = this.state.quotationBreakupPrice != undefined ? this.state.quotationBreakupPrice.filter(
        (x) => x.partId === mainrow.productid
      ) : [];

      const dynamicTableId = `tblCOAchild-${mainrow.productid}-${rowIndex}`;




      const columnCOAChild = [

        {
          dataField: "",
          text: "",

          //headerStyle: {  width: '20px' }, 
          classes: "mt-w91",
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtqty" + rowIndex + "-" + row.id;
            let disable = this.state.formData.CustomerID == 0 ? true : false;
            return (

              <Form.Control
                tabIndex={this.state.tabEnable}
                id={id}
                type="text"
                placeholder="Enter qty"
                value={row.qty}
                onChange={(e) => this.updateStateBreak(e, rowIndex, "qty", id, row.id, row.partId, dynamicTableId)}
                pattern="[+-]?\d+(?:[.,]\d+)?"
                maxLength={20}
                autoComplete="off"
                disabled={disable}
                title=""
                style={{ textAlign: 'right' }}
              //className="mt-w7"
              />

            );
          },

        },



        {
          dataField: "",
          text: "",

          // headerStyle: {  width: '98px' },

          classes: "mt-w7",
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtprice" + rowIndex + "-" + row.id;
            let disable = this.state.formData.CustomerID == 0 ? true : false;
            return (
              <div>
                <Form.Control
                  tabIndex={this.state.tabEnable}
                  id={id}
                  type="text"
                  placeholder="Enter Unit Price"
                  value={row.price}
                  onChange={(e) => this.updateStateBreak(e, rowIndex, "price", id, row.id, row.partId, dynamicTableId)}
                  onBlur={(e: any) => this.amountBlurBreak(e, rowIndex, "price", row.id, row.partId)}
                  onFocus={(e: any) => this.onAmountFocusBreak(e, rowIndex, id, "price", row.id, row.partId)}

                  // onFocus={(e: any) => this.onAmountFocusBreak(e, rowIndex, id, "price", id,row.id,row.partId)}
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  maxLength={20}
                  autoComplete="off"
                  disabled={disable}
                  title=""
                  style={{ textAlign: 'right' }}
                  className="form-control form-control-sm"
                />
              </div>
            );
          },

        },

        {
          dataField: "",
          text: "",

          // headerStyle: {  width: '100%' },
          // headerStyle: {  width: '34px' },
          classes: "mt-w8",
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtprice" + rowIndex + "-" + row.id;
            let disable = this.state.formData.CustomerID == 0 ? true : false;
            return (
              <div>
                <Form.Control
                  tabIndex={this.state.tabEnable}
                  id={id}
                  type="text"
                  placeholder="Enter Unit Price"
                  value={row.price}
                  // onChange={(e) => this.updateStateBreak(e, rowIndex, "price", id,row.id,row.partId,dynamicTableId)}
                  // onBlur={(e: any) => this.amountBlurBreak(e, rowIndex, "price",row.id,row.partId)}
                  // onFocus={(e: any) => this.onAmountFocusBreak(e, rowIndex, id, "price",row.id,row.partId)}

                  // onFocus={(e: any) => this.onAmountFocusBreak(e, rowIndex, id, "price", id,row.id,row.partId)}
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                  maxLength={20}
                  autoComplete="off"
                  disabled={disable}
                  title=""
                  style={{ textAlign: 'right' }}
                  className="d-none"
                />
              </div>
            );
          },

        },



      ];

      const rowStyle = {
        padding: '4px 0', // Adjust padding as needed
        margin: '0',     // Remove margin if needed
      };
      return (
        <>
          {/* <div className='px-4 p-4'> */}
          <div
            className='transactions-list-without-header mt-n1 mt-w1'
          // style={{width:'70%',paddingLeft:'52%',paddingTop:'20px'}}
          >
            <BootstrapTable
              // id="tblCOAchild"
              id={dynamicTableId}
              keyField="id"
              data={splitDetail}
              columns={columnCOAChild}
              //rowEvents={this.rowEvents}
              selectRow={{
                mode: 'checkbox', clickToSelect: false, hideSelectAll: true,
                selected: splitDetail.filter((x) => x.selected === true).map(r => r.id),
                onSelect: this.handleOnSelectPrice,
                onSelectAll: this.handleOnSelectAllPrice,
                hideSelectColumn: false,
                selectColumnStyle: {
                  hidden: true,
                  backgroundColor: '#ffff'
                },
              }}
            // rowClasses={rowStyle }
            //className="custom-table"
            />


          </div>
        </>
      );
    };

    // console.log(this.state.options);

    const files = this.state.newSelectfiles.map((file, index) => (
      <>
        <div>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">
              <div className="file-info d-flex align-items-center">
                <div className="name-loader d-flex align-items-center">
                  <div className="name">
                    <EllipsisWithTooltip placement="bottom">
                      <div
                        className="full-name"
                        onClick={() => {
                          this.handlePreview(file);
                        }}
                      >
                        {file.name}
                      </div>
                    </EllipsisWithTooltip>
                  </div>
                </div>
                <div className="formate-percentage">
                  <div className="formate d-flex justify-content-center align-items-center">
                    {file?.name.substring(
                      file?.name.lastIndexOf(".") + 1,
                      file?.name.length
                    )}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </>
    ));

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <div>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">

              <div className="file-info d-flex align-items-center">
                <div className="name-loader d-flex align-items-center">
                  <div className="name">
                    <EllipsisWithTooltip placement="bottom">
                      <div className="full-name">{file.name}</div>
                    </EllipsisWithTooltip>
                  </div>
                </div>
              </div>
              <div className="action">
                {
                  <Dropdown
                    className="more-action"

                    onSelect={(event: any) =>
                      this.handleSelectFileUpload(event, file, index)
                    }
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    
                    <Dropdown.Menu>
                      {this.state.moreActionFileUpload1.map(
                        (item: any, idx: any) => (
                          <>
                            {this.state.orderid === 0 && (
                              <Dropdown.Item
                              className={(  this.state.moreActionFileUpload1[idx].eventKey === "delete" && !hasDeleteOrderPermission) ? "isHide" : ""}
                              //className={((this.state.formData.actionType === "copy" || this.state.isError === "NotEdit") && this.state.formData.uniqueno > 0) ? "isHide" : ""}
                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}

                            {this.state.orderid > 0 && (
                              <Dropdown.Item
                                className={(  this.state.moreActionFileUpload1[idx].eventKey === "delete" && !hasDeleteOrderPermission) ? "isHide" : ""}
                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}
                          </>
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                }
              </div>
            </div>
          </li>
        </div>
      </>
    ));
    const savedfilesCount = this.state.savedfiles.length;
    const allsavedfiles = this.state.savedfiles;
    const currentView = this.state.defaultView;

    const handleUpdate = (newtext) => {
      //this.setState({ defaultView: "doc-view"});
      toggleSwitch("doc-view");
      setTimeout(function () {
        var currentPos: any = $(`#${newtext}`).offset()?.top;
        var marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      //let docViewerFiles : any =[];
      docViewerFiles.push(docFiles);
      //this.setState({ docViewerFiles: docFiles })
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      // selectedPage =totalpage;
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };


    return (

      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />
          {!this.state.isOpenViewer && !this.state.showMailPanel && (
            <div
              className="back-drop1  viewer-panel1 opacity"
              onClick={() => this.closeSlideOut()}
            ></div>
          )}

            {this.state.showMailPanel &&
              // <div
              //   className="back-drop  viewer-panel opacity z-2 position-absolute"
              //   style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              // >
              <section>
              <div className="details-drawer"
                style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              // className="back-drop1  viewer-panel1 opacity "
              >
                <div
              className="back-drop1  viewer-panel1 opacity"
              onClick={() => this.cancelSendMail()}
            >
            </div>

                <div
                  className="back-drop viewer-panel  z-3 position-absolute"
                  //className="body-sec viewer-panel back-drop p-0 z-3"
                  style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                >
                  <div
                    className="scroll p-3"
                  >
                    <Form>


                      <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold ">Mail To</Form.Label>
                        </div>

                        <FormGroup controlId="mailTo">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="MailTo" value={this.state.mailContent.MailTo}
                              onChange={(event: any) => { this.handleChange(event, "MailTo"); }}

                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>



                      <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold">CC</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="Email" value={this.state.mailContent.CC}
                              onChange={(event: any) => this.handleChange(event, "CC")}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>

                <div className="row my-2">
                        <div className="col-2 ml-3">
                          <Form.Label className="h6 font-semibold">Subject</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-3">
                            <Form.Control type="text" placeholder="Email" value={this.state.mailContent.subject}
                              onChange={(event: any) => this.handleChange(event, "subject")}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>


                      <div className="row my-2 mb-5">
                        <div className="col-2 ml-4">
                          <Form.Label className="h6 font-semibold">Message</Form.Label>
                        </div>

                        <FormGroup controlId="customerName">
                          <div className="col-12 ml-4">
                            <Form.Control type="text" placeholder="Message"
                              as="textarea"
                              wrap="hard"
                              rows={15}
                              value={this.state.mailContent.Message}
                              onChange={(event: any) => this.handleChange(event, "Message")}
                            ></Form.Control>
                          </div>
                        </FormGroup>
                      </div>






                    </Form>
                  </div>
                  <div className={"footer-section viewer-panel"}
                    style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                  >
                    <div className="d-flex gap-3 align-items-center justify-content-between height-72">
                       <div className="d-flex gap-3 align-items-center">
                                           <Form.Check
                                                key="multiple"
                                                type="checkbox"
                                                label="Send Attachments"
                                                className="small-checkbox text-end ms-2"
                                                checked={this.state.isAttachments}
                                                onChange={this.handleAttachment}
                                              /></div>
                      <div className="d-flex gap-3 align-items-center">
                        <Button
                          id="btnCancelSendMail"
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"

                          onClick={() => this.cancelSendMail()}

                        >
                          {"Cancel"}
                        </Button>
                        <Button
                          id="btnSendMail"
                          variant="primary"
                          type="button"
                          onClick={() => this.sendMail()}

                        >
                          {"Send"}
                        </Button>
                      </div>
                    </div>
                  </div>

                </div>
                </div>
                </section>
              // </div>
            }

          {this.state.isOpenViewer && (
            <div
              className="back-drop viewer-panel bg-white z-3 position-absolute"
              //className="body-sec viewer-panel back-drop p-0 z-3"
              style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

            >
              <div
                className="scroll"
              >
                <div className="header-panel d-flex justify-content-between align-items-center">
                  <div className="page-ttl">Attachments</div>
                  {/* <div className="toggle-button">
                    <ButtonGroup aria-label="Basic example">
                      <ToggleButtonGroup
                        type="radio"
                        name="options"
                        value={this.state.defaultView}
                        onChange={toggleSwitch}
                      >
                        <ToggleButton value={"doc-view"} id={""}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                            <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                          </svg>
                        </ToggleButton>
                        <ToggleButton value={"grid-view"} id={""}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                          </svg>
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ButtonGroup>
                  </div> */}
                  <div className="action d-flex">
                    <button
                      type="button"
                      className="btn wht-bg cross"
                      style={{backgroundColor:'#164DA0'}}
                      onClick={this.OpenViewer}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <ScrollContainer
                  className="doc-view scroll-area1"
                  // className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                  //   } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}


                  ref={this.scrollheight}
                  hideScrollbars={false}
                >
                  <>
                    {/* {this.state.savedfiles.map((file: any, i: any) => { */}
           {(this.state.singleView ? this.state.singleViewFiles : this.state.savedfiles).map((file: any, i: any) => {
                      return (
                        <div
                          id={`sec_${file.id}`}
                          className={this.state.bulkSelect ? "footer-enable" : ""}
                        >
                          <div
                            className={
                              currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                            }
                          >
                            <PDFViewer
                              //ref={childViewerref}
                              ref={this["myRef" + i]}
                              scrollAreaHeight={this.state.scrollAreaHeight}
                              isModalOpen={this["isModalOpen"]}
                              uniqueno={this.state.orderID}
                              filePreview={file.fileCode}
                              defaultView={currentView}
                              fileNo={file.fileUniqueno}
                              fileCount={savedfilesCount}
                              fileName={file.name}
                              // docFile={docViewerFiles}
                              docFile={allsavedfiles}
                              updateState={handleUpdate}
                              updateFiles={handleUpdateFiles}
                              showBulkSelect={showBulkSelect}
                              checkBulkSelect={checkBulkSelect}
                              handleFileCheckBox={this["handleFileCheckBox"]}
                              handleUpdatedFile={this["handleUpdatedFile"]}
                              handleincompleteFile={this["handleincompleteFile"]}
                              saveSplitFile={this["saveSplitFile"]}
                              pageType={this.props.pageType}
                              handleRotate={this["handleRotate"]}
                              handlePageRemove={this["handlePageRemove"]}
                              selectedChk={this.state.selectedChk}
                              selectedZoom={this.state.currentZoom}
                              setTotalPages={this["setTotalPages"]}
                              isEditPermission={true}
                            />
                          </div>
                        </div>
                      );
                    })}

                    {currentView === "doc-view" && (
                      <div className="zoom-btn">
                        <ButtonGroup vertical>
                          <Button
                            onClick={(e) => this.handleZoom("zoomIn")}
                            disabled={
                              this.state.currentZoom >= 3.375 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                          <Button
                            onClick={(e) => this.handleZoom("zoomOut")}
                            disabled={
                              this.state.currentZoom <= 0.44 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                    {this.state.bulkSelect && (
                      <div className="footer-section d-flex align-items-center">
                        <Form.Check

                          type="checkbox"
                          key={"custom-footer"}
                          id={"custom-footer"}
                          label={"No Page Selected"}
                          onChange={(e: any) => this.handleAllCheckbox(e)}
                          ref={this.footerchk}
                        />
                      </div>
                    )}
                  </>
                </ScrollContainer>
              </div>
            </div>
          )}

          <Container
            fluid

            className="body-sec viewer-panel back-drop p-0"
            style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

          >


            <div
              className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"  >
              <div className="divheader">
                <h5 className="my-title">
                  {this.state.orderid == 0 && <span>New {this.state.orderType}Quotation</span>}
                  {this.state.orderid != 0 && (
                    <span>Quotation No : {this.state.formData.CustomerPoNumber}</span>
                  )}
                </h5>
                <div className="header-popout ml-auto">


                  <div className="container text-center">
                    <div className="row align-items-start">
                      <div className="col">
                      </div>
                      <div className="col">
                        {this.state.orderid != 0
                          //  && this.state.jobTrackerId === 0 
                          //                             && !this.state.processVendorPOCreated && !this.state.materialVendorPOCreated
                          &&

                          <div className="action">

                            <Dropdown
                              className="more-action"

                              onSelect={(event: any) => { this.moreActions(event); }}
                            >
                              <Dropdown.Toggle
                                className="btn-outline-primary btn btn-primary more"
                                id="dropdown-more"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                </svg>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {this.state.orderid != 0 && (
                                  <>
                                    <Dropdown.Item
                                      eventKey={"print"}
                                      key={1}
                                    >
                                      {"Print"}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                    eventKey={"Email"}
                                    key={1}
                                    >
                                     {"Email"}
                                    </Dropdown.Item>
                                    {hasConvertOrderPermission && ( <>
                                    <Dropdown.Item
                                      eventKey={"DuplicateOrder1"}
                                      key={2}
                                    >
                                      {"Convert to order with attachment"}
                                    </Dropdown.Item>
                                     <Dropdown.Item
                                      eventKey={"DuplicateOrder2"}
                                      key={3}
                                    >
                                      {"Convert to order without attachment"}
                                    </Dropdown.Item>
                                    </>
                                    )}
                                    <Dropdown.Item
                                      eventKey={"DuplicateQuotation"}
                                      key={4}
                                    >
                                      {"Duplicate Quotation"}
                                    </Dropdown.Item>
                                    {hasDeleteOrderPermission &&
                                    <Dropdown.Item
                                      eventKey={"Delete"}
                                      key={5}
                                    >
                                      {"Delete"}
                                    </Dropdown.Item>
                                   } 
                                   {this.state.status !="Closed" && hasEditOrderPermission &&
                                    <Dropdown.Item
                                      eventKey={"Close"}
                                      key={6}
                                    >
                                      {"Mark as Closed"}
                                    </Dropdown.Item>}
                                  </>
                                )}

                              </Dropdown.Menu>
                            </Dropdown>



                          </div>


                        }
                      </div>
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-primary cross"
                          onClick={this.closeSlideOut}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

            </div>
            <div
              className="scroll"
            >
              <section className="pb-3">
                <div className="row g-3">

                  <div className="col-12 col-md-4" >
                    <div className="card h-100">
                      <div className="card-header">
                        Customer Details
                      </div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-12" >
                            <Form.Group controlId="customerName">
                              <div className="parent my-data">
                                <Form.Label className="font-semibold">
                                  Customer Name
                                </Form.Label>
                                <div
                                  tabIndex={this.state.tabEnable}
                                  className="type-head"
                                >
                                  <CustomerSearch
                                    ref={this.customerSearch}
                                    updateCustomerList={this.updateCustomerList}
                                    handleCustomerChange={
                                      this.handleCustomerChange
                                    }
                                  />
                                  {/* <div className="d-inline-block">
                                    {this.state.formData.CustomerID > 0 && this.state.previousOrderData.length > 0 &&
                                      <a onClick={() => this.showprevious()} className="orderLinks" >{this.state.isprevious == false ? "Show Previous orders" : "Hide Previous orders"}   </a>
                                    }
                                  </div> */}
                                </div>
                              </div>
                            </Form.Group>
                          </div>

                          <div className="col-md-12" >
                            <Form.Group controlId="buyerName">
                              <div className="parent my-data">
                                <Form.Label className="font-semibold">
                                  Contact Name
                                </Form.Label>
                                <div
                                  tabIndex={this.state.tabEnable}
                                  className="type-head"
                                >
                                  {/* <Form.Control
                                    tabIndex={this.state.tabEnable}
                                    id="txtBuyerName"
                                    type="text"
                                    placeholder="Enter Buyer Name."
                                    value={this.state.formData.BuyerName}
                                    onChange={(event: any) => this.handleChange(event, 'BuyerName')}
                                    autoComplete="off"

                                    disabled={false}
                                    title=""
                                  /> */}
                                  <Typeahead

                                    id="selections-example"
                                    labelKey="name"
                                    onInputChange={(text: string, e: ChangeEvent<HTMLInputElement>) => {
                                      // console.log(text, e);
                                      this.state.formData.BuyerName = text;
                                    }}
                                    onChange={(e) => this.handleChangeBuyer(e)}
                                    options={this.state.options}
                                    placeholder="Select contact details..."
                                    selected={this.state.Defaultselected}
                                  />
                                </div>
                              </div>
                            </Form.Group>

                          </div>


                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="col-12 col-md-4"   >
                    <div className="card h-100">
                      <div className="card-header">
                        Quotation Details
                      </div>
                      <div className="card-body">
                        <div className="row g-3">

                          <div className="col-md-12" >
                            <Form.Group controlId="vendorName">
                              <div className="parent my-data">
                                <Form.Label className="font-semibold">
                                  Quotation Date
                                </Form.Label>
                                <div className="date-picker calender-picker">


                                  <DatePicker
                                    ref={this.trDate}
                                    id="txtOrderDate"
                                    tabIndex={this.state.tabEnable}
                                    className="form-control px-0 w-75 text-start px-2"
                                    placeholderText={"MM/DD/YY"}
                                    dateFormat="MM/dd/yy"
                                    // selected={
                                    //   this.state.formData.OrderDate === null
                                    //     ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                                    //     : this.state.formData.OrderDate === ""
                                    //       ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                                    //       : new Date(this.state.formData.OrderDate)
                                    // }
                                    selected={
                                      this.state.formData.OrderDate === null
                                        ? null
                                        : this.state.formData.OrderDate === ""
                                          ? null
                                          : new Date(this.state.formData.OrderDate)
                                    }
                                    onChange={(event: any) =>
                                      this.handleChange(event, "orderDate")
                                    }
                                    // onKeyDown={(e: any) =>
                                    //   this.onTAB("txtOrderDate-1", 0, e)
                                    // }
                                    onClick={(e: any) =>
                                      this.onTAB("txtOrderDate-1", 0, e)
                                    }
                                    autoComplete="off"
                                  // disabled={isBedgeProcessing && true}
                                  />
                                </div>
                              </div>
                            </Form.Group>
                          </div>
                          <div className="col-md-12" >
                            <Form.Group controlId="vendorName">
                              <div className="parent my-data">
                                <Form.Label className="font-semibold">
                                  Customer Ref. No
                                </Form.Label>
                                <div
                          tabIndex={this.state.tabEnable}
                          className="type-head"
                        >
                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtcustomerRefNo"
                            type="text"
                            placeholder="Enter Customer Ref No."
                            value={this.state.formData.customerRefNo}
                            onChange={(event: any) => this.handleChange(event, 'customerRefNo')}
                            autoComplete="off"
                            className="w-full"
                            //disabled={true}
                            title=""
                          />
                        </div>
                              </div>
                            </Form.Group>
                          </div>


                        </div>
                          
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                  <div className="card h-100">
                    <div className="card-header">
                      Shipping Details
                    </div>
                    <div className="card-body d-flex flex-column" style={{ padding: '1rem' }}>
                      <Form.Group controlId="exampleForm.ControlTextarea1" className="flex-grow-1">
                        <Form.Label className="font-semibold">
                          Address
                        </Form.Label>
                        <Form.Control
                          id="txtaddress"
                          as="textarea"
                          className="txtarea"
                          rows={4}
                          value={this.state.formData.Address}
                          disabled={true}
                          maxLength={99}
                          style={{ resize: "none", height: '80%', flexGrow: 1 }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>


                </div>
              </section>

              <div className="table-responsive table-responsive1" >
                <section className="pb-3">
                  <div
                  //className="transactions-list"

                  >
                    <div
                      id="order"
                    //className="table-responsive"
                    //className={this.state.responsive} 
                    //style={{minHeight:"170px"}}
                    >
                      {this.state.transactionsColumns.length > 0 && (
                        <div
                          className="table table-borderless align-middle transactions-list"

                        >

                          <BootstrapTable
                            id="tblOrder"
                            keyField="itemNo"
                            data={this.state.orderData}
                            columns={this.state.transactionsColumns}
                            // rowEvents={this.rowEvents1}
                            selectRow={{
                              mode: 'checkbox', clickToSelect: false, hideSelectAll: false,
                              selected: this.state.orderData.filter((x) => x.selected === true).map(r => r.itemNo),
                              onSelect: this.handleOnSelect,
                              onSelectAll: this.handleOnSelectAll,
                              hideSelectColumn: this.state.orderid == 0 ? true : false,
                            }}
                            expandRow={expandSplitRow}

                          />

                        </div>
                      )}
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <div className="d-flex action-btn align-items-center">
                        <Button
                          type="button"
                          className="btn-ghost mr-auto"
                          onClick={this.handleNewRow}
                        >
                          <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Row</span>
                        </Button>




                      </div>
                    </div>
                  </div>
                </section>
                <hr></hr>
                <div >


                  <div className="row">
                    <div className="col-12 col-md-6">


                      <div
                        className="filter-sec upload-section"
                      >

                        <Form.Group className="w-100">

                          <div>
                            <Form.Label>
                              {
                                <div className="upload-link mrgn-top">
                                  <button
                                    type="button"
                                    className="btn wht-bg link-btn mr-auto"
                                  >
                                    Add Attachment
                                  </button>
                                  <Form.Control
                                    id="formControlsFile"
                                    type="file"
                                    className="form-control-file"
                                    multiple
                                    onChange={(event: any) =>
                                      this.onFileChange(event, "1")
                                    }
                                    accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                  />
                                </div>
                              }
                            </Form.Label>

                            {this.state.savedfiles.length > 0 && (
                              <Form.Label className="mr-auto">
                                <div className="upload-link mrgn-top">
                                  <button
                                    type="button"
                                    className="btn wht-bg link-btn mr-auto"
                                    onClick={this.OpenViewer}
                                  // data-bs-toggle="modal" data-bs-target="#exampleModal"
                                  >
                                    {this.state.isOpenViewer
                                      ? "Close Viewer"
                                      : "Open Viewer"}
                                  </button>
                                </div>
                              </Form.Label>
                            )}


                            <div className="mt-1 py-3 rounded-3 text-center text-secondary"
                              style={{ border: "solid 1px #c0c0c0" }}>
                              <Dropzone
                                // disabled={isBedgeProcessing}
                                onDrop={this.onDrop}
                              // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                              >
                                {({
                                  getRootProps,
                                  getInputProps,
                                  isDragActive,
                                  isDragReject,
                                }) => (
                                  <>
                                    <aside>
                                      {/* <ul>{files}</ul> */}
                                      <ul>{files1}</ul>
                                       <ul style={{textAlign:'left'}}> 
                                                                                                                                                                           {this.state.savedfiles.length> 0 && (
                                                                                                                                 
                                                                                                                                                                           <Form.Label>
                                                                                                                                                                           {
                                                                                                                                                                             <div className="upload-link mrgn-top">
                                                                                                                                                                               <button
                                                                                                                                                                                 type="button"
                                                                                                                                                                                 className="btn"
                                                                                                                                                                                 style={{fontSize:'14px'}}
                                                                                                                                                                                 onClick={this.handleButtonClick}
                                                                                                                                                                               >
                                                                                                                                                                                 <FaCirclePlus style={{color:'#164DA0'}} className="align-middle lh-1`" />{" "}
                                                                                                                                                                                 <span style={{color:'#164DA0'}}>Add Attachment</span>
                                                                                                                                                                               </button>
                                                                                                                                                                               <Form.Control
                                                                                                                                                                                 ref={this.fileInputRef}
                                                                                                                                                                                 id="formControlsFile"
                                                                                                                                                                                 type="file"
                                                                                                                                                                                 className="form-control-file"
                                                                                                                                                                                 multiple
                                                                                                                                                                                 onChange={(event: any) =>
                                                                                                                                                                                   this.onFileChange(event, "1")
                                                                                                                                                                                 }
                                                                                                                                                                                 accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                                                                                                                               />
                                                                                                                                                                             </div>
                                                                                                                                                                           }
                                                                                                                                                                           </Form.Label>
                                                                                                                                 
                                                                               )}</ul>
                                    </aside>
                                    <section className="container upload-area default">
                                      {/* {!this.state.bulkSelect && ( */}
                                      {this.state.savedfiles.length < 1 && (
                                        <div
                                          {...getRootProps({
                                            className:
                                              "dropzone align-items-center",
                                            onClick:(event) => event,
                                              // this.state.newSelectfiles.length > 0 ||
                                              //   this.state.savedfiles.length > 0
                                              //   ? (event) => event.stopPropagation()
                                              //   : (event) => event,
                                          })}
                                        >
                                          <input {...getInputProps()} />
                                          {/* {this.state.newSelectfiles.length < 1 && */}
                                            {this.state.savedfiles.length < 1 && (
                                              <p>
                                                Drag and drop attachment or{" "}
                                                <span>browse files</span> to upload.
                                              </p>
                                            )}
                                          {(this.state.newSelectfiles.length > 0 ||
                                            this.state.savedfiles.length > 0)
                                            &&
                                            isDragActive && (
                                              <p>
                                                Drag and drop attachment here to upload.
                                              </p>
                                            )}
                                          {/* {!isDragActive && (<p>Drag and drop or <span>browse files</span> to upload</p>)} */}
                                        </div>
                                        // </div>
                                      )}
                                      {/* {this.state.bulkSelect && (
                                                                        <div className="dropzone d-flex align-items-center">
                                                                            <p>Drag and drop or <span>browse files</span> to upload</p>
                                                                        </div>
                                                                    )} */}
                                      {

                                      }
                                      {/* <aside>

                                          <ul >{files}</ul>
                                          <ul >{files1}</ul>

                                        </aside> */}

                                    </section>


                                  </>
                                )}

                              </Dropzone>

                            </div>
                          </div>
                        </Form.Group>
                      </div>

                    </div>


                    <div className="col-12 col-md-6">
                      {(this.state.orderid != 0 &&
                        <CommentBox
                          ref={this.ChildComment}
                          hotelid={this.state.hotelValue}
                          entryType={"Quotation"}
                          //={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                          uniqueNo={this.state.orderid}
                          precommentlist={this.state.htmlcomment}
                          parentScrollMethod={this.scrollToBottom}
                          updatedCommentItem={this.updatedCommentItem}
                          commentModalClose={this.CommentModalClose}

                        />
                      )}
                    </div>
                  </div>


                </div>
              </div>
              <div className="filter-sec height-172">

                <br></br>
                <br></br>

              </div>
              {this.state.isStateChanged && (
              <div className={"footer-section viewer-panel"}
                style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              >
                <div>
                  <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                    {this.state.isStateChanged && <div className="mr-auto message">
                      <span style={{ color: '#065a8c' }}>You have unsaved changes</span>
                    </div>}
                    <div className="d-flex gap-3 align-items-center">
                      {this.state.isStateChanged &&
                        this.state.formData.CustomerID > 0 && (
                          <>
                            <Button
                              variant="primary"
                              type="button"
                              className="space btn btn-primary btn-discard"
                              onClick={() =>
                                this.handleDiscard(this.state.orderUniqueNo)
                              }
                            >
                              Discard
                            </Button>
                            {((hasEditOrderPermission && this.state.orderid != 0) || (hasAddOrderPermission && this.state.orderid === 0)) && (
                            <Button
                              id="btnSave"
                              variant="primary"
                              type="button"
                              onClick={() => this.saveOrderfinal("order", false, false)}
                              disabled={
                                this.state.formData.CustomerID === 0
                                  ? true
                                  : this.state.isDisabled
                              }
                              onKeyDown={(e: any) =>
                                this.onTAB("btnSave-1", 0, e)
                              }
                            >
                              {this.state.orderid != 0 ? "Update" : "Save"}
                            </Button>
                            )}
                          </>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              )}




            </div>




            {this.state.isDuplicate && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body">
                      <h1>Confirmation</h1>
                      This part is already added.
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.CancelRow(e)}
                        >
                          Ok
                        </button>
                        {/* <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.AddedRow(e)}
                        >
                          Yes
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.unsave && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body"
                    
                    >
                      <h1>Confirmation</h1>
                      Please save this record before creating Price Breakup.
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.Cancelunsave(e)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn"
                          //  onClick={(e) => this.saveOrderfinal("order", false,false)}
                          onClick={() => {this.saveOrderfinal("orderjob", false, false),this.reopen();}}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
               {this.state.isattachFile && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body"
                    
                    >
                      <h1>Confirmation</h1>
                      Please save the record before attaching file.
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.Cancelunsave1(e)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn"
                          onClick={() => this.saveOrderfinal("order", false, false)}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {(this.state.isSpinner || this.state.isSaveSpinner) && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}
            {this.state.showBreakdown &&
              <section>
                <div className="d-flex">
                  <div
                    className="back-drop1 viewer-panel1 opacity z-1"
                    onClick={() => this.closeSlideOut()}
                  ></div>
                  <Container
                    fluid
                    className="body-sec viewer-panel back-drop .shadow-left-corners px-4"
                    style={{
                      minWidth: '48%',
                      width: '100%',
                      maxWidth: '900px',
                      zIndex: 12,
                      padding: '10px',
                      backgroundColor: 'white',
                      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)'
                    }}
                  >
                    {/* <div className="divheader" style={{ backgroundColor: '#e9ecef' }}>
              <h6 className="my-title">Price Breakdown  ( {this.state.selectedpart} )</h6>
              <div className="action d-flex">
                    <button
                      type="button"
                      className="btn btn-primary cross1"
                      onClick={this.closePricebreakdown}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                          fill="white"
                          
                        />
                      </svg>
                    </button>
                  </div>
            </div> */}
                    <div className="header-container d-flex justify-content-between align-items-center">
                      <h6 className="my-title text-truncate d-flex align-items-center gap-2 mb-0">
                      <EllipsisWithTooltip placement="bottom">

                        Price Breakdown : {this.state.selectedpart} 
                        </EllipsisWithTooltip>
                        <a className="orderLinks ms-3" onClick={(e)=>{ this.setState({ showPartPopup: true,selectedPartId:0 ,selectedJobId:0});}}>Select from Database</a>
                        </h6>
                      <div className="action">
                        <button
                          type="button"
                          className="btn btn-primary cross1"
                          onClick={this.closePricebreakdown}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0',
                            border: 'none',
                            background: '#164DA0'
                          }}
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              display: 'block'
                            }}
                          >
                            <path
                              d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>


                    <section>

                      <div>

                      {/* <section style={{ marginTop: '2%', marginRight: '1.8%' }}>
                            <div className="table-responsive mt-2">
                              <div className="ml-auto transactions-list">
                            
                                 <BootstrapTable
                                id="tblpricebreakup"
                                keyField="rowId"
                                data={this.state.qoSetup.filter(x=>x.itemName=="Quantity")}
                                columns={columns}
                            
                              />
                              </div>
                            </div>
                          </section> */}
                        <section style={{ overflowX: 'auto' }}>
                          <div className="table-responsive mt-2" style={{ maxHeight: '400px' }}>
                            <div className="ml-auto transactions-list">
                              <BootstrapTable
                                id="tblpricebreakup"
                                keyField="rowId"
                                data={this.state.qoSetup}
                                columns={columns}
                            
                              />
                            </div>
                          </div>
                        </section>
                        <h6 style={{ color: 'green', cursor: 'pointer', marginTop: '2%', marginBottom: "2%" }} onClick={this.handleNewRowPrice}>+ Add Row</h6>

                        <div>

                          <section style={{ marginTop: '2%', marginRight: '0.4%' }}>
                            <div className="table-responsive mt-2">
                              <div className="ml-auto transactions-list">
                                <BootstrapTable
                                  id="tblpricebreakupp"
                                  keyField="partId"
                                  data={[this.state.totals]}
                                  columns={columns1}
                                />
                                <BootstrapTable
                                  id="tblExpand"
                                  keyField="partId"
                                  data={[this.state.totalsExpand]}
                                  columns={columns2}
                                />
                              </div>
                            </div>
                          </section>


                        </div>

                        <hr style={{ border: '1px solid black' }} />
                        {hasEditOrderPermission &&
                        <div className="d-flex justify-content-end gap-3" style={{ marginTop: '2%', marginBottom: '2%' }}>
                          {/* <Button variant="primary" style={{marginRight: '10px'}} onClick={this.closePricebreakdown}>Discard</Button> */}
                          <Button variant="primary" style={{ marginRight: '10px' }} onClick={() => { this.setState({ showReset: true }); }}>Reset</Button>
                          <Button variant="primary" style={{ marginRight: '10px' }} onClick={() => this.saveData(0)}>Save</Button>


                          <span className="schedule-lock" data-tip={tooltipMessage}>
                            <ReactTooltip
                              effect="solid"
                              event="mouseover mouseenter"
                              eventOff="mouseleave mouseout scroll mousewheel blur"
                              place="left"
                              multiline={true}
                            />
                            <span className="budget-settings-main recalculate-budgets-wrapper">
                              <span className={this.state.isicon == false ? "" : "pip-icon red"}></span>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.saveData(1)}
                                style={{ marginRight: '20px' }}
                              >

                                Apply
                              </button>
                            </span>
                          </span>
                          {/* <Button variant="primary" style={{marginRight: '20px'}} onClick={() => this.saveData(1)}>Save & Apply</Button>   */}
                        </div>}
                      </div>
                      {this.state.showReset && (
                        <div style={{
                          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
                        }}>
                          <ConfirmationModal
                            confirmModalContent={[{
                              title: "Reset Data",
                              desc: "Are you sure you want to reset the data?",
                              cancleAction: "Cancel",
                              ActionTrue: "Reset",
                            }]}
                            ishandleDeletePosition={this.handleResetData}
                          />
                        </div>

                      )}

                       {this.state.showApplyPopup && (
                        <div style={{
                          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
                        }}>
                          <ConfirmationModal
                            confirmModalContent={[{
                              title: "Confirmation",
                              desc: "Do you want to update the Part Master with this data?",
                              cancleAction: "No",
                              ActionTrue: "Yes",
                            }]}
                            ishandleDeletePosition={this.handleApplyData}
                          />
                        </div>

                      )}

                    </section>
                  </Container>
                </div>

                {this.state.showPartPopup && (
                               <div
                               //className="d-flex align-items-center pos-fxd2 index-1000"
                               >
                                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                                    <div className="react-confirm-alert">
                                      <div className="react-confirm-alert-body partprocess-popup-width">
                                        <div>
                                          <div className="d-flex">
                                         
                                            <div className="header-popout ml-auto">
                                              <button
                                                type="button"
                                                className="btn wht-bg cross"
                                                onClick={(e)=>{this.setState({ showPartPopup: false });}}
                                              >
                                                <svg
                                                  width="24"
                                                  height="24"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                                    fill="#84888C"
                                                  />
                                                </svg>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                    
                
                
                                        <div className="container my-3" >
                                  <div className="col-12">
                                  <div style={{height:'400px', overflowY:'scroll'}}>
                                  
                                  
                                  <div className="process" >
                                  <div className="left-panel" >
                            
                                    
                                    <Tab.Container   transition={false} defaultActiveKey="first" >
                    
                    <section className='p-2'>
                <Nav   className="nav nav-underline border-bottom">
                <Nav.Item className="nav-item">
                  <Nav.Link eventKey="first">Part 
                  
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="nav-item">
                  <Nav.Link eventKey="second">Job 
                  
                  </Nav.Link>
                </Nav.Item>
                
                </Nav>
                </section>
                
                <Tab.Content>
                <Tab.Pane eventKey="first">
                
                {true && 
                                   
                                   
                                   
                                   
                                   <ToolkitProvider
                                   keyField="id"
                                   data={this.state.productList}
                                             columns={this.state.partcolumns}
                                    //className="table table-striped table-borderless align-middle"
                                   search
                                 >
                                   {(props: {
                                           searchProps: JSX.IntrinsicAttributes;
                                           baseProps: JSX.IntrinsicAttributes;
                                         }) => (
                       
                       
                                       <div >
                                         <section className="d-flex flex-wrap">
                                         <div className="search-header w-auto px-2 pb-2">
                                               <SearchBar
                                                 {...props.searchProps}
                                                 placeholder={"Search"}
                                               />
                                             </div>
                       
                                           <div 
                                           //className="input-group w-auto"
                                           >
                                             
                                           </div>
                       
                                         </section>
                                         <section >
                                         
                                             <BootstrapTable
                                           
                                               {...props.baseProps}
                                               hover
                                               condensed
                                                selectRow = {{
                                                 mode: 'radio',
                                                 clickToSelect: true,
                                                 classes: "table-active",
                                                 hideSelectColumn: true,  
                                                 onSelect: this.handlePartOnSelect,
                                                 selected: [this.state.selectedPartId],
                                               }}
                                             />
                                           
                                         </section>
                                       </div>
                       
                                     )
                                   }
                                 </ToolkitProvider>
                                 
                                 
                                           
                                           }
                
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                
                {true && 
                                   
                                   
                                   
                                   
                                   <ToolkitProvider
                                   keyField="jobId"
                                   data={this.state.jobList}
                                             columns={this.state.jobcolumns}
                                    //className="table table-striped table-borderless align-middle"
                                   search
                                 >
                                   {(props: {
                                           searchProps: JSX.IntrinsicAttributes;
                                           baseProps: JSX.IntrinsicAttributes;
                                         }) => (
                       
                       
                                       <div >
                                         <section className="d-flex flex-wrap">
                                         <div className="search-header w-auto px-2 pb-2">
                                               <SearchBar
                                                 {...props.searchProps}
                                                 placeholder={"Search"}
                                               />
                                             </div>
                       
                                           <div 
                                           //className="input-group w-auto"
                                           >
                                             
                                           </div>
                       
                                         </section>
                                         <section >
                                         
                                             <BootstrapTable
                                           
                                               {...props.baseProps}
                                               hover
                                               condensed
                                                selectRow = {{
                                                 mode: 'radio',
                                                 clickToSelect: true,
                                                 classes: "table-active",
                                                 hideSelectColumn: true,  
                                                 onSelect: this.handleJobOnSelect,
                                                 selected: [this.state.selectedJobId],
                                               }}
                                             />
                                           
                                         </section>
                                       </div>
                       
                                     )
                                   }
                                 </ToolkitProvider>
                                 
                                 
                                           
                                           }
                
                </Tab.Pane>
                </Tab.Content>
                
                </Tab.Container>
                                   
                                    
                                    </div>
                                    </div> 
                                    </div>
                                  </div>
                            
                                 
                              </div>
                                       
                <div className="react-confirm-alert-button-group">
                            
                                  {
                                    this.state.selectedPartId > 0 && (
                                      <>
                                      
                                        <Button
                                          variant="primary"
                                          type="button"
                                          className="space btn btn-primary btn-discard"
                                          onClick={(e) => {this.applyTemplate();}}
                                          
                                        >
                                          Apply
                                        </Button>
                
                                        <Button
                                          variant="primary"
                                          type="button"
                                          className="space btn btn-primary btn-discard"
                                          onClick={(e)=>{this.setState({ showPartPopup: false });}}
                                        >
                                          Discard
                                        </Button>
                                      </>
                                    )
                                  }
                                 
                                
                           
                          </div>
                                      </div>
                                    </div>
                            
                                  </div>
                                </div>
                              )}
                
              </section>
            }

   { /* Description modal */}
   <Modal show={this.state.showPopup} onHide={()=>{this.setState({showPopup:false});}}>
          <Modal.Header>
            <Modal.Title>Edit Part Description</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Part Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote}
                onChange={(e)=>{this.setState({ currentNote: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup:false});}}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleNotesSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

   { /* Notes modal */}
   <Modal show={this.state.showPopup1} onHide={()=>{this.setState({showPopup1:false});}}>
          <Modal.Header>
            <Modal.Title>Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Add Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote1}
                disabled={!((hasEditOrderPermission && this.state.orderid != 0) || (hasAddOrderPermission && this.state.orderid === 0))}
                onChange={(e)=>{this.setState({ currentNote1: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup1:false});}}>
              Cancel
            </Button>
            {((hasEditOrderPermission && this.state.orderid != 0) || (hasAddOrderPermission && this.state.orderid === 0)) &&
            <Button variant="primary" onClick={this.handleNotesSave1}>
              Save
            </Button>
            }
          </Modal.Footer>
        </Modal>


          </Container>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId 
});


export default connect(mapStateToProps)(Quotationslideout);